<template>
  <div>
    <v-container max-height="100px">
      <panels-toolbar
        :items="data.items"
        :selectedTable="selectedTable"
        :selectedTables="selectedTables"
        :receiptNote="receiptNote"
        :currency="currency"
        :discount="data.discount"
        :keyboardShortcutsEnabled="keyboardShortcutsEnabled"
        :showShortcutBadges="showShortcutBadges"
        :showBadgesTemporarily="showBadgesTemporarily"
        @openSearchItemsDialog="openSearchItemsDialog"
        @openCloseBalanceDialog="openCloseBalanceDialog"
        @openReceiptsDialog="openReceiptsDialog"
        @finishPaymentRep="confirmReprezentacija()"
        @deliveryFinishPayment="deliveryFinish"
        @openSplitReceiptDialog="openSplitReceiptDialog"
        @addWriteInProduct="onAddWriteInProduct"
        @printRecapitulation="onPrintRecapitulation"
      ></panels-toolbar>
      <!------------------------------------------------------------------------- ODABIR PLAĆANJA BUTTON -->
      <!-- Payment Selection Button - single button that opens payment method dialog -->
      <v-row v-if="showPaymentSelectionButton">
        <v-col cols="12" style="padding: 0 0 2px 0">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="openPaymentMethodDialog"
                  :disabled="!buttonsEnabled"
                >
                  <span v-if="!smallWindow" class="btn-text-glass tile btn-lg">PLAĆANJE</span>
                  <v-icon class="icon-glass" large v-if="smallWindow">mdi-currency-eur</v-icon>
                </v-btn>
                <!-- Keyboard shortcut badge for Enter -->
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  ⏎
                </v-chip>
              </div>
            </template>
            <span>Otvori modal za odabir načina plaćanja</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!------------------------------------------------------------------------- PAYMENT METHODS ROW -->
      <!-- Payment Methods Row - only show if at least one method enabled and not VP register -->
      <v-row v-if="showPaymentRow && cashRegisterType !== 'VP'">
        <!------------------------------------------------------------------------- GOTOVINSKI -->
        <!-- Gotovinski - conditional display and dynamic width -->
        <v-col
          v-if="enabledPaymentMethods.cash && cashRegisterType !== 'VP'"
          :cols="paymentButtonCols"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="handleGotovinaClick"
                  :disabled="!buttonsEnabled || cashRegisterType === 'VP'"
                >
                  <span v-if="!smallWindow" class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.paymentMethods.cash")
                  }}</span>
                  <v-icon class="icon-glass" large v-if="smallWindow"
                    >mdi-currency-eur</v-icon
                  >
                </v-btn>
                <!-- Keyboard shortcut badge for Gotovina (G) -->
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  G
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.payWithCash") }}</span>
          </v-tooltip>
        </v-col>

        <!------------------------------------------------------------------------- KARTIČNO -->
        <!-- Kartično - conditional display and dynamic width -->
        <v-col
          v-if="enabledPaymentMethods.card && cashRegisterType !== 'VP'"
          :cols="paymentButtonCols"
          style="padding: 0 2px 2px 0"
        >
          <v-menu bottom right>
            <template v-slot:activator="{ on: onMenu, attrs }">
              <v-tooltip
                bottom
                :open-delay="tooltipDelay"
                :open-on-hover="true"
                :open-on-click="false"
                :open-on-focus="false"
              >
                <template #activator="{ on: onTooltip }">
                  <div
                    v-on="{ ...onMenu, ...onTooltip }"
                    style="position: relative"
                  >
                    <v-btn
                      class="payment-btn-glass"
                      block
                      tile
                      depressed
                      min-height="3.5rem"
                      icon
                      :disabled="!buttonsEnabled || cashRegisterType === 'VP'"
                      v-bind="attrs"
                      @click="handleKarticaClick"
                    >
                      <span
                        v-if="!smallWindow"
                        class="btn-text-glass tile btn-lg"
                        >{{ $t("$vuetify.paymentMethods.card") }}</span
                      >
                      <v-icon class="icon-glass" large v-if="smallWindow"
                        >mdi-credit-card-outline</v-icon
                      >
                    </v-btn>
                    <!-- Keyboard shortcut badge for Kartično (K) -->
                    <v-chip
                      v-if="
                        keyboardShortcutsEnabled &&
                        (showShortcutBadges || showBadgesTemporarily)
                      "
                      x-small
                      color="white"
                      text-color="primary"
                      style="
                        position: absolute;
                        bottom: 4px;
                        right: 4px;
                        font-weight: bold;
                        min-width: 20px;
                      "
                    >
                      K
                    </v-chip>
                  </div>
                </template>
                <span>{{ $t("$vuetify.tooltips.payWithCards") }}</span>
              </v-tooltip>
            </template>
          </v-menu>
        </v-col>

        <!------------------------------------------------------------------------- R1 -->
        <!-- R1 - conditional display and dynamic width -->
        <v-col
          v-if="enabledPaymentMethods.r1"
          :cols="paymentButtonCols"
          style="padding: 0 0 2px 0"
        >
          <v-menu bottom right>
            <template v-slot:activator="{ on: onMenu, attrs }">
              <v-tooltip
                bottom
                :open-delay="tooltipDelay"
                :open-on-hover="true"
                :open-on-click="false"
                :open-on-focus="false"
              >
                <template #activator="{ on: onTooltip }">
                  <div v-on="{ ...onMenu, ...onTooltip }">
                    <v-btn
                      class="payment-btn-glass"
                      block
                      tile
                      depressed
                      min-height="3.5rem"
                      icon
                      :disabled="!buttonsEnabled"
                      v-bind="attrs"
                      @click="openR1ReceiptPaymentDialog"
                    >
                      <span class="btn-text-glass tile btn-lg">R1</span>
                    </v-btn>
                  </div>
                </template>
                <span>{{ $t("$vuetify.tooltips.payR1") }}</span>
              </v-tooltip>
            </template>
          </v-menu>
        </v-col>
      </v-row>
      <!------------------------------------------------------------------------- RAČUN (SAMO VP) -->
      <v-row v-if="cashRegisterType === 'VP'">
        <v-col cols="12" style="padding: 0 0 2px 0">
          <v-menu bottom right>
            <template v-slot:activator="{ on: onMenu, attrs }">
              <v-tooltip
                bottom
                :open-delay="tooltipDelay"
                :open-on-hover="true"
                :open-on-click="false"
                :open-on-focus="false"
              >
                <template #activator="{ on: onTooltip }">
                  <div v-on="{ ...onMenu, ...onTooltip }">
                    <v-btn
                      class="payment-btn-glass"
                      block
                      tile
                      depressed
                      min-height="3.5rem"
                      icon
                      :disabled="!buttonsEnabled"
                      v-bind="attrs"
                      @click="openWsPaymentDialog"
                    >
                      <span class="btn-text-glass tile btn-lg">Račun</span>
                    </v-btn>
                  </div>
                </template>
                <span>Račun</span>
              </v-tooltip>
            </template>
          </v-menu>
        </v-col>
      </v-row>
      <!------------------------------------------------------------------------- END SELECTING -->
      <!-- Floor Plan Mode: Tlocrt + Nova/Očisti/Spremi -->
      <v-row v-if="useTables && tableMode === 'floor'">
        <!-- Quantity Dropdown (First Column) -->
        <v-col
          v-if="quantityBarEnabled"
          xl="4"
          lg="4"
          md="4"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <quantity-dropdown-compact
            :selected-quantity="selectedQuantity"
            :enabled="true"
            @quantity-changed="onQuantityChanged"
          ></quantity-dropdown-compact>
        </v-col>
        <v-col
          :xl="quantityBarEnabled ? 4 : 6"
          :lg="quantityBarEnabled ? 4 : 6"
          :md="quantityBarEnabled ? 4 : 6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="openFloorPlan"
                >
                  <span class="btn-text-glass tile btn-lg">STOLOVI</span>
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  T
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.floorPlan.openFloorPlan") }}</span>
          </v-tooltip>
        </v-col>
        <v-col
          :xl="quantityBarEnabled ? 4 : 6"
          :lg="quantityBarEnabled ? 4 : 6"
          :md="quantityBarEnabled ? 4 : 6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="onNewOrder"
                >
                  <span class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.tables.new")
                  }}</span>
                </v-btn>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.newOrder") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- Floor Plan Mode Row 2: Clear + Save buttons -->
      <v-row v-if="useTables && tableMode === 'floor'">
        <v-col
          xl="6"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  :disabled="
                    selectedTable.number === 0 || data.items.length === 0
                  "
                  min-height="3.5rem"
                  @click="onClearOrder"
                >
                  <span class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.tables.clear")
                  }}</span>
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  O
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.clearTable") }}</span>
          </v-tooltip>
        </v-col>
        <v-col xl="6" lg="6" md="6" sm="12" xs="12" style="padding: 0 0 2px 0">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  block
                  tile
                  depressed
                  :disabled="
                    selectedTable.number === 0 || data.items.length === 0 || saveDisabledAfterSplit
                  "
                  min-height="3.5rem"
                  class="save-btn-glass"
                  @click="onSaveItemsToTable"
                >
                  <span
                    v-if="selectedTable.number !== 0"
                    class="btn-text-glass tile btn-lg"
                    >{{ `${$t("$vuetify.tables.saveTable")}` }}</span
                  >
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  S
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.saveTable") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- Regular Mode: Standard Table Buttons -->
      <v-row v-if="useTables && tableMode === 'list'">
        <!-- Quantity Dropdown (First Column) -->
        <v-col
          v-if="quantityBarEnabled"
          xl="4"
          lg="4"
          md="4"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <quantity-dropdown-compact
            :selected-quantity="selectedQuantity"
            :enabled="true"
            @quantity-changed="onQuantityChanged"
          ></quantity-dropdown-compact>
        </v-col>
        <v-col
          :xl="quantityBarEnabled ? 4 : 6"
          :lg="quantityBarEnabled ? 4 : 6"
          :md="quantityBarEnabled ? 4 : 6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="onOpenTablesDialog"
                >
                  <span class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.tables.select")
                  }}</span>
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  T
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.selectTable") }}</span>
          </v-tooltip>
        </v-col>
        <v-col
          :xl="quantityBarEnabled ? 4 : 6"
          :lg="quantityBarEnabled ? 4 : 6"
          :md="quantityBarEnabled ? 4 : 6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  min-height="3.5rem"
                  @click="onNewOrder"
                >
                  <span class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.tables.new")
                  }}</span>
                </v-btn>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.newOrder") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- List Mode Row 2: Clear + Save buttons -->
      <v-row v-if="useTables && tableMode === 'list'">
        <v-col
          xl="6"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          style="padding: 0 2px 2px 0"
        >
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  class="payment-btn-glass"
                  block
                  tile
                  depressed
                  :disabled="
                    selectedTable.number === 0 || data.items.length === 0
                  "
                  min-height="3.5rem"
                  @click="onClearOrder"
                >
                  <span class="btn-text-glass tile btn-lg">{{
                    $t("$vuetify.tables.clear")
                  }}</span>
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  O
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.clearTable") }}</span>
          </v-tooltip>
        </v-col>
        <v-col xl="6" lg="6" md="6" sm="12" xs="12" style="padding: 0 0 2px 0">
          <v-tooltip
            bottom
            :open-delay="tooltipDelay"
            :open-on-hover="true"
            :open-on-click="false"
            :open-on-focus="false"
          >
            <template #activator="{ on }">
              <div v-on="on" style="position: relative">
                <v-btn
                  block
                  tile
                  depressed
                  :disabled="
                    selectedTable.number === 0 || data.items.length === 0 || saveDisabledAfterSplit
                  "
                  min-height="3.5rem"
                  class="save-btn-glass"
                  @click="onSaveItemsToTable"
                >
                  <span
                    v-if="selectedTable.number !== 0"
                    class="btn-text-glass tile btn-lg"
                    >{{ `${$t("$vuetify.tables.saveTable")}` }}</span
                  >
                </v-btn>
                <v-chip
                  v-if="
                    keyboardShortcutsEnabled &&
                    (showShortcutBadges || showBadgesTemporarily)
                  "
                  x-small
                  color="white"
                  text-color="primary"
                  style="
                    position: absolute;
                    bottom: 4px;
                    right: 4px;
                    font-weight: bold;
                    min-width: 20px;
                  "
                >
                  S
                </v-chip>
              </div>
            </template>
            <span>{{ $t("$vuetify.tooltips.saveTable") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- Tables wrapper with relative positioning -->
      <div v-if="useTables && tableMode === 'list'" class="tables-wrapper">
        <!-- Scroll Up Button -->
        <v-row v-if="tablesCanScrollUp" class="scroll-button-row-up">
          <v-col cols="12" class="pa-0">
            <v-btn
              block
              elevation="0"
              @click="scrollTablesUp"
              class="scroll-button"
            >
              <v-icon>mdi-chevron-double-up</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Selected Tables List (only in regular mode) -->
        <div
          ref="tablesScrollContainer"
          @scroll="updateTablesScrollState"
          class="tables-scroll-container"
        >
        <v-row>
        <v-col
          xl="3"
          lg="4"
          md="6"
          sm="12"
          xs="12"
          v-for="(table, idxc) in selectedTables"
          :key="idxc"
          class="panel-cell"
          align="center"
        >
          <div v-if="!table.type">
            <div
              style="
                border-top-right-radius: 12px;
                border-top-left-radius: 12px;
              "
              :ref="table.id"
              :key="timerCount"
              :class="
                showWaitingTime(table.update_time, table.id, true) < 1800000
                  ? 'notification-green'
                  : showWaitingTime(table.update_time, table.id, true) < 3600000
                  ? 'notification-yellow'
                  : 'notification-red'
              "
            >
              {{ showWaitingTime(table.update_time, table.id) }}
            </div>
            <v-btn
              v-longpress:[table]="renameTable"
              :style="
                tableLocked(table)
                  ? 'background-color: rgba(97, 84, 164, 0.3)'
                  : `background-color: ${table.color}`
              "
              block
              tile
              depressed
              min-height="3.5rem"
              :color="table.color"
              return-object
              @click="onTableCellClick(table)"
            >
              <span class="white--text tile btn-md">{{ table.name }}</span>
            </v-btn>
            <div
              style="
                border-bottom-left-radius: 12px;
                border-bottom-right-radius: 12px;
                background: linear-gradient(135deg, #36485B 0%, #307CC1 100%);
                color: white;
                font-weight: bold;
              "
            >
              {{ calculateTotalOnTable(table.items) }}
            </div>
          </div>
          <div
            v-if="
              useTables && tableMode === 'list' &&
              table.type &&
              table.type === 'tableDialogOpener' &&
              selectedTables.length > 1
            "
          >
            <div
              style="
                border-top-right-radius: 12px;
                border-top-left-radius: 12px;
                color: rgba(97, 84, 164, 1);
              "
              :ref="table.id"
              :key="timerCount"
              :class="'notification-purple'"
              st
            >
              Stolovi
            </div>
            <v-btn
              class="payment-btn-glass stolovi-btn"
              block
              tile
              depressed
              min-height="56px"
              @click="showTbls = true"
              style="position: relative;"
            >
              <span class="btn-text-glass tile btn-lg">Stolovi</span>
              <!-- Keyboard shortcut badge for Stolovi (T) -->
              <v-chip
                v-if="
                  keyboardShortcutsEnabled &&
                  (showShortcutBadges || showBadgesTemporarily)
                "
                x-small
                color="white"
                text-color="primary"
                style="
                  position: absolute;
                  bottom: 4px;
                  right: 4px;
                  font-weight: bold;
                  min-width: 20px;
                "
              >
                T
              </v-chip>
            </v-btn>
            <div
              class="stolovi-bottom"
              style="
                border-bottom-left-radius: 12px;
                border-bottom-right-radius: 12px;
                background: linear-gradient(135deg, #36485B 0%, #307CC1 100%);
                color: white;
                font-weight: bold;
              "
            >
              &nbsp;
            </div>
          </div>
        </v-col>
      </v-row>
      </div>

        <!-- Scroll Down Button -->
        <v-row v-if="tablesCanScrollDown" class="scroll-button-row-down">
          <v-col cols="12" class="pa-0">
            <v-btn
              block
              elevation="0"
              @click="scrollTablesDown"
              class="scroll-button scroll-button-down"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-dialog
        v-model="showTbls"
        v-if="showTbls"
        content-class="my-custom-dialog"
        transition="dialog-top-transition"
        persistent
        scrollable
        max-width="60%"
        @keydown.esc="showTbls = false"
      >
        <v-card
          tile
          color="white"
          class="pb-3"
          style="border-radius: 25px !important"
        >
          <v-card-title
            class="d-flex"
            style="
              vertical-align: middle;
              background-color: #1577da;

              height: 58px;
              color: white;
            "
          >
            <span class="text-h5" style="font-weight: bold">{{
              $t("$vuetify.tables.tables")
            }}</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="white pt-5 pb-5">
            <v-container class="panel-container">
              <v-row>
                <v-col
                  :cols="3"
                  v-for="(table, idxc) in selectedTables.slice(1)"
                  :key="idxc"
                  class="panel-cell"
                  align="center"
                >
                  <div
                    style="
                      border-top-right-radius: 12px;
                      border-top-left-radius: 12px;
                    "
                    :ref="table.id"
                    :key="timerCount"
                    :class="
                      showWaitingTime(table.update_time, table.id, true) <
                      1800000
                        ? 'notification-green'
                        : showWaitingTime(table.update_time, table.id, true) <
                          3600000
                        ? 'notification-yellow'
                        : 'notification-red'
                    "
                  >
                    {{ showWaitingTime(table.update_time, table.id) }}
                  </div>
                  <v-btn
                    v-longpress:[table]="renameTable"
                    :style="
                      tableLocked(table)
                        ? 'background-color: rgba(97, 84, 164, 0.3)'
                        : `background-color: ${table.color}`
                    "
                    block
                    tile
                    depressed
                    min-height="3.5rem"
                    :color="table.color"
                    return-object
                    @click="onTableCellClick(table, true)"
                  >
                    <span class="white--text tile btn-md">{{
                      table.name
                    }}</span>
                  </v-btn>
                  <div
                    style="
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                      background: linear-gradient(135deg, #36485B 0%, #307CC1 100%);
                      color: white;
                      font-weight: bold;
                    "
                  >
                    {{ calculateTotalOnTable(table.items) }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="d-flex pt-0 mt-0 pr-7 justify-end">
            <v-btn class="btn dangerButton" @click="showTbls = false">
              Odustani
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <tables-dialog
      v-if="addTableDialogOpen"
      :availableTables="availableTables"
      @addTable="onAddTable"
      @selectTable="onSelectTable"
      @saveTable="saveTable"
      @deleteTable="onDeleteTable"
      @closeTablesDialog="onCloseTablesDialog"
    ></tables-dialog>
    <account-details-dialog
      v-if="r1DialogOpen"
      :data="data"
      :paymentMethod="paymentMethod"
      :selectedTable="selectedTable"
      :selectedTables="selectedTables"
      :selectedPrinter="selectedPrinter"
      :selectedTerminal="selectedTerminal"
      :showPreview="showPreview"
      @closeR1Dialog="onR1DialogClose"
      @imidiatePrintPrepare="imidiatePrintPrepare"
      @accountDetailsFinishPayment="onAccountDetailsFinishPayment"
      @accountDetailsPreviewReceipt="onAccountDetailsPreviewReceipt"
    ></account-details-dialog>
    <split-receipt-dialog
      ref="splitReceiptDialog"
      :selectedTable="selectedTable"
      :selectedTables="selectedTables"
      :availableTables="availableTables"
      :data="data"
      @createNewTable="onCreateNewTable"
      @addItemsToTable="onAddItemsToTable"
    ></split-receipt-dialog>
    <terminals ref="terminals" @terminalSelected="terminalSelected"></terminals>
    <v-dialog v-model="tableRename" width="25%">
      <v-card>
        <v-card-title> Preimenuj stol</v-card-title>
        <v-card-text>
          <v-text-field v-model="newTableName"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="border-radius: 12px"
            color="primary"
            variant="text"
            @click="updateTableName()"
          >
            Spremi
          </v-btn>

          <v-btn
            style="border-radius: 12px"
            color="primary"
            variant="text"
            @click="tableRename = false"
          >
            Otkaži
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <card-payment-selection-dialog
      ref="cardSelectionDialog"
      :cards="availableCards"
      @checkTerminal="checkTerminal"
    ></card-payment-selection-dialog>
    <r1-receipt-payment-dialog
      ref="r1ReceiptPaymentDialog"
      :paymentMenu="paymentMenu"
      @menuPaymentClick="menuPaymentClick"
      @checkCardsForR="checkCardsForR"
    ></r1-receipt-payment-dialog>
    <ws-payment-selection-dialog
      ref="wsPaymentSelectionDialog"
      :paymentMenu="paymentMenu"
      @menuPaymentClick="menuPaymentClick"
      @checkCards="checkCards"
    ></ws-payment-selection-dialog>
    <floor-plan-dialog
      ref="floorPlanDialog"
      :available-tables="availableTables"
      :read-only-mode="true"
    ></floor-plan-dialog>
    <payment-method-dialog
      ref="paymentMethodDialog"
      :buttonsEnabled="buttonsEnabled"
      :showShortcutBadges="showShortcutBadges"
      @payment-method-selected="onPaymentMethodSelected"
    ></payment-method-dialog>

    <!-- Table selection with cart items dialog -->
    <v-dialog
      v-model="tableSelectionDialogOpen"
      persistent
      max-width="650"
      style="z-index: 7"
    >
      <v-card class="table-selection-card">
        <div class="table-selection-header">
          <v-icon left color="white" size="28">mdi-alert</v-icon>
          <span class="table-selection-title">Odaberi akciju</span>
        </div>

        <v-card-text class="table-selection-text">
          {{ $t("$vuetify.tables.noteMessage") }}
        </v-card-text>

        <v-card-text class="table-selection-buttons pt-2 pb-0">
          <v-row>
            <v-col cols="6" class="pb-2">
              <v-btn
                @click="onTableSelectionCancel"
                class="table-selection-cancel-btn"
                elevation="4"
                block
                x-large
              >
                <div class="table-btn-content">
                  <v-icon size="48" class="mb-2"
                    >mdi-close-circle-outline</v-icon
                  >
                  <div class="table-btn-text">
                    {{ $t("$vuetify.tables.cancel") }}
                  </div>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="6" class="pb-2">
              <v-btn
                @click="onTableSelectionDeleteOrder"
                class="table-selection-delete-btn"
                elevation="4"
                block
                x-large
              >
                <div class="table-btn-content">
                  <v-icon size="48" class="mb-2">mdi-delete-outline</v-icon>
                  <div class="table-btn-text">
                    {{ $t("$vuetify.tables.deleteOrder") }}
                  </div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-btn
                @click="onTableSelectionAddToTable"
                class="table-selection-add-btn"
                elevation="4"
                block
                x-large
              >
                <div class="table-btn-content">
                  <v-icon size="48" class="mb-2">mdi-table-arrow-down</v-icon>
                  <div class="table-btn-text">
                    {{ $t("$vuetify.tables.addToTable") }}
                    {{ pendingTable ? pendingTable.name : "" }}
                  </div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Success snackbar for table save -->
    <v-snackbar
      v-model="showSuccessSnackbar"
      :timeout="3000"
      color="success"
      top
      right
    >
      <v-icon left color="white">mdi-check-circle</v-icon>
      Artikli uspješno spremljeni na stol
    </v-snackbar>

    <!-- Transfer loading overlay - GLOBALNI, preko cijelog ekrana -->
    <div
      v-if="isProcessingTransfer"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.90);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: all;
      "
    >
      <div style="text-align: center;">
        <v-progress-circular
          :size="120"
          :width="12"
          color="#04aa6d"
          indeterminate
        ></v-progress-circular>
        <div style="color: white; font-size: 24px; margin-top: 24px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);">
          Prebacivanje artikala...
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import rules from '@/plugins/rules'
import state from '@/state'
import { auth, df, functions } from '@/plugins/firebase'
import { toISOLocal, clone } from '@/plugins/utils'
import AccountDetailsDialog from '@/modules/cash-register/components/dialogs/AccountDetailsDialog'
import PanelsToolbar from '@/modules/cash-register/components/PanelsToolbar'
import TablesDialog from '@/modules/cash-register/components/dialogs/TablesDialog.vue'
import SplitReceiptDialog from '@/modules/cash-register/components/dialogs/SplitReceiptDialog'
import { printOrder } from '@/libs/bixolon/order'
import Terminals from '@/modules/cash-register/components/dialogs/Terminals.vue'
import Table from '@/model/Table'
import WriteInProductModel from '@/model/WriteInProduct'
import CardPaymentSelectionDialog from '@/modules/cash-register/components/dialogs/CardPaymentSelectionDialog'
import R1ReceiptPaymentDialog from '@/modules/cash-register/components/dialogs/R1ReceiptPaymentDialog'
import WsPaymentSelectionDialog from '@/modules/cash-register/components/dialogs/WsPaymentSelectionDialog'
import PaymentMethodDialog from '@/modules/cash-register/components/dialogs/PaymentMethodDialog'

import { remapItems } from '@/libs/receiptIssuing/items'
import { getPayload, getVirmanPayload } from '@/libs/receiptIssuing/payload'
import { getPaymentMethod } from '@/libs/receiptIssuing/commons'
import { sendHttp, sendVirmanHttp, sendPreview } from '@/libs/receiptIssuing/payment'

import { v4 as uuidv4 } from 'uuid'
import EventBus from '@/plugins/event-bus'
import { retry } from '@/libs/receiptIssuing/validation'
import { doPrintCartRecapitulation } from '@/libs/bixolon/reprint.js'
import LogData from '@/model/LogData'
import log from '@/mixins/log'
import FloorPlanDialog from '@/modules/cash-register/components/dialogs/FloorPlanDialog.vue'
import QuantityDropdownCompact from '@/modules/cash-register/components/register-wide/QuantityDropdown.vue'

export default {
  components: {
    AccountDetailsDialog,
    TablesDialog,
    PanelsToolbar,
    SplitReceiptDialog,
    Terminals,
    CardPaymentSelectionDialog,
    R1ReceiptPaymentDialog,
    WsPaymentSelectionDialog,
    FloorPlanDialog,
    PaymentMethodDialog,
    QuantityDropdownCompact
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    selectedPrinter: {
      // Passed over from PanelRows or PanelRowsWide
      type: Object,
      default: () => { }
    },
    keyboardShortcutsEnabled: {
      type: Boolean,
      default: false
    },
    showShortcutBadges: {
      type: Boolean,
      default: false
    },
    showBadgesTemporarily: {
      type: Boolean,
      default: false
    },
    quantityBarEnabled: {
      type: Boolean,
      default: false
    },
    selectedQuantity: {
      type: Number,
      default: 1
    }
  },
  inject: ['showMsgBox', 'confirm', 'confirmClose', 'showLoader', 'hideLoader', 'openPdfPrint'],
  mixins: [log],
  data: function () {
    return {
      isProcessingPayment: false, // Flag to prevent double receipt creation
      processingReceiptNumbers: new Set(), // Track receipt numbers currently being sent
      tableRename: false,
      isProcessingTransfer: false, // Zaštita od duplih transfera
      saveDisabledAfterSplit: false,
      timerCount: 0,
      user: undefined,
      tableToRename: undefined,
      initialTableName: undefined,
      manager: false,
      userId: undefined,
      r1DialogOpen: false,
      addTableDialogOpen: false,
      note: '',
      languages: [],
      language: undefined,
      receiptNumber: 1,
      bill_sequence: 0,
      offer_sequence: 0,
      last_receipt: '',
      receiptType: '',
      receiptTypes: [],
      defaultReceiptTypes: [],
      multiplier: 0,
      // fiscalize: false,
      issueDate: '',
      minIssueDate: '',
      maxIssueDate: '',
      useFloorPlan: false, // deprecated - calculated from useTables && tableMode
      useTables: true, // Master switch
      tableMode: 'list', // 'list' ili 'floor'
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        gt: rules.gt,
        arrReq: rules.arrReq()
      },
      listeners: [],
      type: '',
      cashRegisterForTerminal: undefined,
      paymentMethod: '',
      keypadNumber: '',
      editMode: false,
      ordersView: false,
      selectedTable: {},
      selectedTables: [],
      availableTables: [],
      destinationTable: {},
      initialTable: {},
      printers: [],
      orgUnits: [],
      paymentMenu: [
        { text: this.$t('$vuetify.paymentMethods.cash'), type: 'G', icon: 'mdi-cash' },
        { text: this.$t('$vuetify.paymentMethods.card'), type: 'K', icon: 'mdi-card' },
        { text: this.$t('$vuetify.paymentMethods.transaction'), type: 'T', icon: 'mdi-card' },
        { text: this.$t('$vuetify.paymentMethods.virman'), type: 'V', icon: 'mdi-card' }
      ],
      availableCards: [],
      selectedCard: undefined,
      selectedTerminal: undefined,
      tableNameSuffix: 1,
      receiptNote: null,
      tableForRename: undefined,
      newTableName: '',
      tooltipDelay: 500,
      showPreview: false,
      previewReceiptType: 'R',
      currency: 'EUR',
      smallWindow: false,
      showTbls: false,
      selectedCostCenter: undefined,
      paymentReference: undefined,
      tableSelectionDialogOpen: false,
      pendingTable: null,
      showSuccessSnackbar: false,
      showSuccessMessageOnSave: false,
      // Tables scroll state
      tablesScrollPosition: 0,
      tablesCanScrollUp: false,
      tablesCanScrollDown: false,
      // Payment methods configuration - local reactive copy
      localEnabledPaymentMethods: { cash: true, card: true, r1: true, paymentSelection: false }
    }
  },
  computed: {

    storeReceiptNumber () {
      if (this.receiptType && this.receiptType.value === 'P') {
        return this.offer_sequence
      } else {
        return this.bill_sequence
      }
    },
    buttonsEnabled () {
      return this.data.items.length > 0 && !this.isProcessingPayment
    },
    cashRegisterType () {
      return state.getCashRegister().type
    },

    // Payment methods configuration
    enabledPaymentMethods () {
      return this.localEnabledPaymentMethods
    },

    showPaymentSelectionButton () {
      // Show payment selection button if enabled and not VP register
      return this.enabledPaymentMethods.paymentSelection && this.cashRegisterType !== 'VP'
    },

    enabledCount () {
      const methods = this.enabledPaymentMethods
      let count = 0
      // Don't count individual methods if payment selection is active
      if (methods.paymentSelection) return 0
      if (methods.cash && this.cashRegisterType !== 'VP') count++
      if (methods.card && this.cashRegisterType !== 'VP') count++
      if (methods.r1) count++
      return count
    },

    paymentButtonCols () {
      // Returns column width based on enabled count
      if (this.enabledCount === 0) return 0
      if (this.enabledCount === 1) return 12
      if (this.enabledCount === 2) return 6
      return 4 // three buttons
    },

    showPaymentRow () {
      // Show individual payment buttons (not payment selection button)
      return this.enabledCount > 0 && !this.enabledPaymentMethods.paymentSelection
    }
  },

  watch: {
    storeReceiptNumber (nv) {
      this.receiptNumber = nv + 1
    },
    editMode: {
      handler (nv, ov) {
      }
    },
    cashRegisterType: {
      handler (type) {
        if (type === 'VP') {
          this.paymentMenu = [
            { text: this.$t('$vuetify.paymentMethods.transaction'), type: 'T', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.virman'), type: 'V', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.offer'), type: 'P', icon: 'mdi-card' }
          ]
        } else if (type === 'ALL') {
          this.paymentMenu = [
            { text: this.$t('$vuetify.paymentMethods.cash'), type: 'G', icon: 'mdi-cash' },
            { text: this.$t('$vuetify.paymentMethods.card'), type: 'K', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.transaction'), type: 'T', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.virman'), type: 'V', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.offer'), type: 'P', icon: 'mdi-card' }
          ]
        } else {
          this.paymentMenu = [
            { text: this.$t('$vuetify.paymentMethods.cash'), type: 'G', icon: 'mdi-cash' },
            { text: this.$t('$vuetify.paymentMethods.card'), type: 'K', icon: 'mdi-card' },
            { text: this.$t('$vuetify.paymentMethods.virman'), type: 'V', icon: 'mdi-card' }
          ]
        }
      },
      immediate: true
    },

    selectedTables: {
      handler (selectedTables) {
        clearInterval(this._updateTimer)
        if (selectedTables.length) {
          this._updateTimer = setInterval(() => this.timerCount++, 1000)
        }
        // Update scroll state when tables list changes
        this.$nextTick(() => {
          this.updateTablesScrollState()
        })
      },
      immediate: true
    },
    beforeUnmount () {
      clearInterval(this._updateTimer)
    },
    // Vue 2.x equivalent of beforeUnmount
    beforeDestroy () {
      clearInterval(this._updateTimer)
    }

  },
  methods: {
    handleGotovinaClick () {
      this.finishPayment('G', 'BO')
    },
    handleKarticaClick () {
      this.checkCards()
    },
    // Quantity dropdown handler
    onQuantityChanged (quantity) {
      this.$emit('quantity-changed', quantity)
    },

    getFloorPlanStorageKey () {
      return `use_floor_plan_${state.getCashRegister().id}`
    },
    loadFloorPlanSetting () {
      try {
        const key = this.getFloorPlanStorageKey()
        const saved = localStorage.getItem(key)
        if (saved !== null) {
          this.useFloorPlan = saved === 'true'
        }
      } catch (err) {
        console.error('Error loading floor plan setting:', err)
      }
    },
    saveFloorPlanSetting (value) {
      try {
        const key = this.getFloorPlanStorageKey()
        localStorage.setItem(key, value.toString())
        this.useFloorPlan = value
      } catch (err) {
        console.error('Error saving floor plan setting:', err)
      }
    },
    // New table settings methods
    getTableSettingsStorageKey () {
      return `use_tables_${state.getCashRegister().id}`
    },
    getTableModeStorageKey () {
      return `table_mode_${state.getCashRegister().id}`
    },
    getTableSettingsInitializedKey () {
      return `table_settings_initialized_${state.getCashRegister().id}`
    },
    loadTableSettings () {
      try {
        // Check if this is a migration from old settings
        const oldFloorPlanKey = this.getFloorPlanStorageKey()
        const oldFloorPlanValue = localStorage.getItem(oldFloorPlanKey)

        if (oldFloorPlanValue !== null && !localStorage.getItem(this.getTableSettingsInitializedKey())) {
          // Migration from old useFloorPlan setting
          console.log('Migrating from old floor plan setting in PanelPaymentSelection')
          this.useTables = true
          this.tableMode = oldFloorPlanValue === 'true' ? 'floor' : 'list'
          this.useFloorPlan = oldFloorPlanValue === 'true'
          // Mark as initialized
          localStorage.setItem(this.getTableSettingsInitializedKey(), 'true')
        } else {
          // Load new settings
          const useTablesKey = this.getTableSettingsStorageKey()
          const tableModeKey = this.getTableModeStorageKey()

          const savedUseTables = localStorage.getItem(useTablesKey)
          const savedTableMode = localStorage.getItem(tableModeKey)

          if (savedUseTables !== null) {
            this.useTables = savedUseTables === 'true'
          }
          if (savedTableMode !== null) {
            this.tableMode = savedTableMode
          }

          // Update useFloorPlan for backward compatibility
          this.useFloorPlan = this.useTables && this.tableMode === 'floor'
        }
      } catch (err) {
        console.error('Error loading table settings:', err)
      }
    },
    // Tables scroll methods
    scrollTablesUp () {
      const container = this.$refs.tablesScrollContainer
      if (container) {
        container.scrollBy({
          top: -200,
          behavior: 'smooth'
        })
      }
    },
    scrollTablesDown () {
      const container = this.$refs.tablesScrollContainer
      if (container) {
        container.scrollBy({
          top: 200,
          behavior: 'smooth'
        })
      }
    },
    updateTablesScrollState () {
      const container = this.$refs.tablesScrollContainer
      if (container) {
        this.tablesScrollPosition = container.scrollTop
        this.tablesCanScrollUp = container.scrollTop > 0
        this.tablesCanScrollDown = container.scrollTop + container.clientHeight < container.scrollHeight - 1
      }
    },
    openFloorPlan () {
      if (this.$refs.floorPlanDialog) {
        this.$refs.floorPlanDialog.open()
        // Ensure it opens in user mode (read-only)
        this.$nextTick(() => {
          this.$refs.floorPlanDialog.editMode = false
        })
      }
    },
    handleButtonKeyPress (e) {
      // Ignore if keyboard shortcuts are disabled
      if (!this.keyboardShortcutsEnabled) return

      // Ignore if user is typing in an input field
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return

      // Ignore if any v-dialog is open (payment dialogs, etc.)
      const openDialogs = document.querySelectorAll('.v-dialog--active')
      if (openDialogs.length > 0) return

      // Handle Enter key to open payment method modal
      if (e.key === 'Enter') {
        // Check if payment buttons are enabled
        if (this.buttonsEnabled && this.cashRegisterType !== 'VP') {
          e.preventDefault()
          e.stopPropagation()
          this.openPaymentMethodDialog()
        }
        return
      }

      const key = e.key.toUpperCase()

      // Handle protected keywords for buttons
      switch (key) {
        case 'F': // Find/Search (Pretraga)
          e.preventDefault()
          e.stopPropagation()
          this.openSearchItemsDialog()
          break
        case 'T': // Stolovi (Tables/Floor Plan or Table List)
          // Only handle if tables are enabled
          if (this.useTables) {
            e.preventDefault()
            e.stopPropagation()
            if (this.tableMode === 'floor') {
              // Open floor plan dialog
              this.openFloorPlan()
            } else {
              // Open table selection dialog
              this.onOpenTablesDialog()
            }
          }
          break
        case 'S': // Spremi (Save)
          // Check if button is enabled (same condition as button :disabled)
          if (this.selectedTable.number !== 0 && this.data.items.length > 0 && !this.saveDisabledAfterSplit) {
            e.preventDefault()
            e.stopPropagation()
            this.onSaveItemsToTable()
          }
          break
        case 'O': // Očisti (Clear)
          // Check if button is enabled (same condition as button :disabled)
          if (this.selectedTable.number !== 0 && this.data.items.length > 0) {
            e.preventDefault()
            e.stopPropagation()
            this.onClearOrder()
          }
          break
        case 'G': // Gotovina (Cash)
          // Check if button is enabled (same condition as button :disabled)
          if (this.buttonsEnabled && this.cashRegisterType !== 'VP') {
            e.preventDefault()
            e.stopPropagation()
            this.finishPayment('G', 'BO')
          }
          break
        case 'K': // Kartično (Card)
          // Check if button is enabled (same condition as button :disabled)
          if (this.buttonsEnabled && this.cashRegisterType !== 'VP') {
            e.preventDefault()
            e.stopPropagation()
            this.checkCards()
          }
          break
      }
    },
    calculateTotalOnTable (jsonData) {
      if (!jsonData || !Array.isArray(jsonData) || jsonData.length === 0) {
        return '0,00€'
      }
      const sum = jsonData.reduce((acc, item) => acc + item.total, 0)
      return (sum / 100).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€'
    },
    onAddWriteInProduct (item) {
      this.$emit('addWriteInProduct', item)
    },

    onPrintRecapitulation () {
      doPrintCartRecapitulation(this.data, this.selectedPrinter)
      // this.printCartRecapitulation(this.data, this.selectedPrinter)
    },

    renameTable (table) {
      this.tableForRename = table
      this.newTableName = table.name
      this.tableRename = true
    },
    updateTableName () {
      var tb = this.tableForRename
      var newName = this.newTableName

      this.tableRename = false
      this.tableForRename = undefined
      this.newTableName = ''

      if (this.selectedTable.id === tb.id) {
        this.selectedTable.name = newName
      }

      if (this.selectedTables && this.selectedTables.length > 0) {
        this.selectedTables.forEach((tbl, key) => {
          if (tbl.id === tb.id) {
            this.selectedTables[key].name = newName
          }
        })
      }

      this.updateTableNameInDb(tb.id, newName)
      this.$forceUpdate()
    },
    updateTableNameInDb (tableId, newName) {
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tableId}`).update({
        name: newName
      })
        .then(() => {
          console.info('Table succesfully updated.')
        })
        .catch(() => {
          console.error('Table has not been updated succesfully.')
        })
    },
    // Provjera i ponasanje ako nema aktivnih kartica
    checkCardsForR () {
      if (!this.availableCards || this.availableCards.length === 0) {
        if (this.cashRegisterForTerminal.terminals) {
          var terms = this.cashRegisterForTerminal.terminals
          var termsArray = []
          if (terms && Object.keys(terms).length > 0) {
            Object.keys(terms).forEach(key => {
              termsArray.push(terms[key])
            })

            // Ako postoji vise terminala, dopusti odabir bilo kojeg
            if (termsArray && termsArray.length > 1) {
              this.$refs.terminals.open(this.cashRegisterForTerminal, undefined, 'K', 'R')
            } else if (termsArray && termsArray.length === 1) {
              // Ako postoji ima samo jedan terminal, salji na njega
              this.selectedTerminal = termsArray[0]
              this.insertAccountDetails('K', 'R', undefined, undefined)
            } else {
              // Ako nema ni jedan terminal, samo napravi racun
              this.insertAccountDetails('K', 'R', undefined, undefined)
            }
          }
        } else {
          // Ako nema ni jedan terminal, samo napravi racun
          this.insertAccountDetails('K', 'R', undefined, undefined)
        }
      } else {
        this.openCardSelectionDialog('R')
      }
    },

    openCardSelectionDialog (type) {
      this.$refs.cardSelectionDialog.open(type)
    },
    openR1ReceiptPaymentDialog (mode) {
      this.$refs.r1ReceiptPaymentDialog.open(mode)
    },
    openWsPaymentDialog () {
      this.$refs.wsPaymentSelectionDialog.open()
    },

    // Provjera i ponasanje ako nema aktivnih kartica
    checkCards () {
      if (!this.availableCards || this.availableCards.length === 0) {
        // Nema aktivnih kartica
        if (this.cashRegisterForTerminal.terminals) {
          var terms = this.cashRegisterForTerminal.terminals
          var termsArray = []
          if (terms && Object.keys(terms).length > 0) {
            Object.keys(terms).forEach(key => {
              termsArray.push(terms[key])
            })

            // Ako postoji vise terminala, dopusti odabir bilo kojeg
            if (termsArray && termsArray.length > 1) {
              this.$refs.terminals.open(this.cashRegisterForTerminal, undefined, 'K', 'BO')
            } else if (termsArray && termsArray.length === 1) {
              // Ako postoji ima samo jedan terminal, salji na njega
              this.finishPayment('K', 'BO', undefined, undefined, termsArray[0])
            } else {
              // Ako nema ni jedan terminal, samo napravi racun
              this.finishPayment('K', 'BO', undefined, undefined)
            }
          }
        } else {
          // Ako nema ni jedan terminal, samo napravi racun
          this.finishPayment('K', 'BO', undefined, undefined)
        }
      } else {
        // Ima aktivnih kartica, pokaži dialog za odabir
        this.openCardSelectionDialog('BO')
      }
    },

    // Open payment method selection modal
    openPaymentMethodDialog () {
      if (this.$refs.paymentMethodDialog) {
        this.$refs.paymentMethodDialog.open()
      }
    },

    // Handle payment method selection from modal
    onPaymentMethodSelected (method) {
      switch (method) {
        case 'cash':
          // Gotovina - same as G key
          this.finishPayment('G', 'BO')
          break
        case 'card':
          // Kartica - same as K key
          this.checkCards()
          break
        case 'r1':
          // R1 Receipt
          this.$refs.r1ReceiptPaymentDialog.open()
          break
      }
    },

    terminalSelected (terminal, paymentCard, method, receiptType) {
      this.selectedTerminal = terminal

      if (receiptType === 'R') {
        this.insertAccountDetails('K', 'R', undefined, paymentCard)
      } else {
        this.finishPayment(method, receiptType, undefined, paymentCard, terminal)
      }
    },
    checkTerminal (method, receiptType, deliveryName = undefined, paymentCard = undefined) {
      var termsWithCards = []
      if (this.cashRegisterForTerminal.terminals) {
        var terms = this.cashRegisterForTerminal.terminals

        Object.keys(terms).forEach(key => {
          if (terms[key].cards && terms[key].cards.length === 0) {
            termsWithCards.push(terms[key])
          }

          if (terms[key].cards && terms[key].cards.length > 0 && terms[key].cards.some(card => card.ID === paymentCard.id)) {
            termsWithCards.push(terms[key])
          }
        })
      }

      if (termsWithCards) {
        switch (termsWithCards.length) {
          case 0:
            if (receiptType === 'R') {
              this.insertAccountDetails('K', 'R', undefined, paymentCard)
            } else {
              this.finishPayment(method, receiptType, undefined, paymentCard)
            }
            break
          case 1:
            var terminal = termsWithCards[0]
            if (receiptType === 'R') {
              this.selectedTerminal = terminal
              this.insertAccountDetails('K', 'R', undefined, paymentCard)
            } else {
              this.finishPayment(method, receiptType, undefined, paymentCard, terminal)
            }
            break
          default:
            this.$refs.terminals.open(this.cashRegisterForTerminal, paymentCard, method, receiptType)
            break
        }
      }
    },

    showWaitingTime (updateDate, tableId, mode = false) {
      const diff = new Date() - new Date(updateDate)
      const twoD = x => `${Math.floor(x)}`.padStart(2, '0')
      const HH = twoD((diff / (60 * 60 * 1000)) % 24)
      const mm = twoD((diff / (60 * 1000)) % 60)
      const ss = twoD((diff / 1000) % 60)
      if (mode) return diff
      else { return `${HH}:${mm}:${ss}` }
    },
    openSplitReceiptDialog () {
      this.$refs.splitReceiptDialog.open(this.selectedTable)
    },
    // From split receipt
    async onCreateNewTable (sourceTable, destinationTable) {
      // ✅ Early return ako je transfer već u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Transfer već u tijeku, ignoriram dupli poziv')
        return
      }

      this.isProcessingTransfer = true
      console.log('🔄 Započinjem kreiranje novog stola...')

      try {
        this.selectedTable = clone(sourceTable)
        this.destinationTable = clone(destinationTable)

        await this.updateTable(this.selectedTable)
        await this.addSplitTable(this.destinationTable, this.selectedTable)

        this.$emit('createNewTable', this.selectedTable, destinationTable)
        console.log('✅ Novi stol uspješno kreiran')

        // Emit event to clear pending quantities after creating new table
        EventBus.$emit('table-saved-clear-pending')

        // Čekaj da Vue ažurira DOM (košaricu) prije nego zatvorimo overlay
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 400))
        console.log('🎨 DOM ažuriran, zatvaram overlay')

        // Emituj EventBus event da je operacija završena
        EventBus.$emit('table-transfer-completed')
      } catch (error) {
        console.error('❌ Greška pri kreiranju novog stola:', error)

        // PRVO zatvori overlay i dijalogeđ
        this.isProcessingTransfer = false
        EventBus.$emit('table-transfer-completed')

        // Čekaj da se overlay zatvori
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        // TEK ONDA prikaži grešku sa detaljima
        const errorMessage = error.message || error.toString() || 'Nepoznata greška'
        this.showMsgBox({
          title: 'Greška',
          text: `Dogodila se greška pri kreiranju novog stola:\n${errorMessage}\n\nMolimo pokušajte ponovo.`
        })
      } finally {
        // Flag je već resetiran u catch bloku ako je bilo greške
        this.isProcessingTransfer = false
      }
    },
    async onAddItemsToTable (sourceTable, targetTable, itemsToTransfer) {
      // ✅ Early return ako je transfer već u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Transfer već u tijeku, ignoriram dupli poziv')
        return
      }

      this.isProcessingTransfer = true

      try {
        const transferTableItemsApi = functions.httpsCallable('transfertableitems')
        await transferTableItemsApi({
          action: {
            resource_id: '',
            operation: 'create',
            entity: 'table_items',
            params: {
              from_table_id: sourceTable.id,
              to_table_id: targetTable.id,
              location_id: state.getPointOfSale().id,
              items: itemsToTransfer
            }
          }
        })

        await this.onNewOrder()
        console.log('✅ Transfer uspješno završen, košarica osvježena')

        // Emit event to clear pending quantities after transfer
        EventBus.$emit('table-saved-clear-pending')

        // Čekaj da Vue ažurira DOM (košaricu) prije nego zatvorimo overlay
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))
        console.log('🎨 DOM ažuriran, zatvaram overlay')

        // Emituj EventBus event da je transfer završen
        EventBus.$emit('table-transfer-completed')
      } catch (error) {
        console.error('❌ Greška pri transferu:', error)

        // PRVO zatvori overlay i dijaloge
        console.log('PanelPaymentSelection: Resetiram isProcessingTransfer na false zbog greške')
        this.isProcessingTransfer = false
        EventBus.$emit('table-transfer-completed')

        // Čekaj da se overlay zatvori
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        // TEK ONDA prikaži grešku sa detaljima
        const errorMessage = error.message || error.toString() || 'Nepoznata greška'
        this.showMsgBox({
          title: 'Greška',
          text: `Dogodila se greška pri transferu artikala:\n${errorMessage}\n\nMolimo pokušajte ponovo.`
        })
      } finally {
        // Flag je već resetiran u catch bloku ako je bilo greške
        console.log('PanelPaymentSelection: Finally blok - isProcessingTransfer =', this.isProcessingTransfer)
        this.isProcessingTransfer = false
      }
    },
    confirmReprezentacija () {
      this.confirm({
        title: 'Reprezentacija',
        message: 'Ovaj račun će biti reprezentacija, jeste li sigurni da želite nastaviti?',
        options: {
          toolbar: true,
          width: 410,
          confirmText: this.$t('$vuetify.yes'),
          cancelText: this.$t('$vuetify.no')
        }
      }).then((resp) => {
        if (resp) {
          this.confirmClose()
          this.finishPayment('O', 'REPREZENTACIJA')
        }
      })
    },
    deliveryFinish (delivery) {
      this.finishPayment('O', 'DELIVERY', delivery.value)
    },
    menuPaymentClick (menu) {
      switch (menu.type) {
        case 'G':
          this.insertAccountDetails('G', 'R')
          break
        case 'K':
          this.insertAccountDetails('K', 'R')
          break
        case 'V':
          this.insertAccountDetails('V', 'R')
          break
        case 'T':
          this.insertAccountDetails('T', 'R')
          break
        case 'P':
          this.insertAccountDetails('P', 'R')
      }
    },
    tableLocked (table) {
      return !this.editMode && table.locked && table.locked_by !== state.getUser().id
    },
    switchLocks (newSelectedTable, oldSelectedTable) {
      this.lock(newSelectedTable)

      if (oldSelectedTable.id) {
        this.unlock(oldSelectedTable)
      } else {
        this.selectedTable = newSelectedTable
      }
    },
    async lock (newSelectedTable) {
      const me = this

      const newUpdateArgs = { locked: true, color: 'rgba(97, 84, 164, 0.95)', locked_by: state.getUser().id }
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${newSelectedTable.id}`).update(newUpdateArgs)
        .then(() => {
        }).catch((err) => {
          console.error(err)
          me.showMsgBox({ text: 'Pogreška prilikom zaključavanja', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
      this.selectedTable = newSelectedTable

      this.$emit('selectTable', newSelectedTable)
    },
    async unlock (oldSelectedTable) {
      const me = this

      const oldUpdateArgs = { locked: false, color: 'primary' }
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${oldSelectedTable.id}`).update(oldUpdateArgs)
        .then(() => {
        })
        .catch((err) => {
          console.error(err)
          me.showMsgBox({ text: 'Pogreška prilikom zaključavanja', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
    },
    onOpenTablesDialog () {
      if (!this.orderHasChanged()) {
        this.addTableDialogOpen = true
      } else {
        this.confirm({
          title: this.$t('$vuetify.tables.note'),
          message: this.$t('$vuetify.tables.noteMessage'),
          options: {
            toolbar: true,
            width: 410,
            confirmText: this.$t('$vuetify.tables.continue'),
            cancelText: this.$t('$vuetify.tables.cancel')
          }
        }).then(async (resp) => {
          if (resp) {
            this.addTableDialogOpen = true
          }
          this.confirmClose()
        })
      }
    },
    onCloseTablesDialog () {
      this.addTableDialogOpen = false
    },
    async onAddTable (table) {
      if (this.selectedTable.id) {
        const oldTb = clone(this.selectedTable)
        this.unlock(oldTb)
        this.selectedTable = table
        this.initialTable = clone(this.selectedTable)
        this.clearOrderFromScreen()
        this.$emit('selectTable', table)
        this.$emit('recalculate')
      } else {
        // Stol nije odabran
        if (this.selectedTable.number !== 0) {
          const oldTb = clone(table)
          const newTb = clone(this.selectedTable)
          this.switchLocks(oldTb, newTb)
          this.initialTable = clone(newTb)
        } else {
          this.selectedTable = table
          var initTable = clone(table)
          delete initTable.items
          this.initialTable = clone(initTable)

          this.data.items.forEach(item => {
            this.selectedTable.items.push(item)
          })
          this.$emit('selectTable', table)
        }
        this.onSaveItemsToTable()
      }

      // if (this.data.items.length > 0) {
      //   this.confirm({
      //     title: this.$t('$vuetify.tables.save_title'),
      //     message: `${this.$t('$vuetify.tables.save')} ${table.name}?`,
      //     options: {
      //       toolbar: true,
      //       width: 410,
      //       confirmText: this.$t('$vuetify.yes'),
      //       cancelText: this.$t('$vuetify.no')
      //     }
      //   }).then((resp) => {
      //     if (this.selectedTable.number !== 0) {
      //       const oldTb = clone(table)
      //       const newTb = clone(this.selectedTable)
      //       this.switchLocks(oldTb, newTb)
      //       this.initialTable = clone(newTb)
      //     } else {
      //       this.selectedTable = table
      //       this.initialTable = clone(this.selectedTable)
      //     }
      //     if (resp) {
      //       this.confirmClose()
      //       this.onSaveItemsToTable()
      //     } else {
      //       this.clearOrderFromScreen()
      //       this.$emit('recalculate')
      //     }
      //   })
      // } else {
      //   this.onSelectTable(table)
      // }
    },
    onSelectTable (table) {
      this.saveDisabledAfterSplit = false
      if (this.data.items.length > 0) {
        this.selectedTable.items = [...this.data.items]
      }
      if (table.discount) {
        this.data.discount = table.discount
      }
      if (table.number === this.selectedTable.number) {
        this.selectedTable = table
        this.data.items = [...this.selectedTable.items]

        this.initialTable = clone(table)

        this.$emit('selectTable', table)
        this.$emit('recalculate')
      } else {
        const oldTb = clone(table)
        const newTb = clone(this.selectedTable)
        this.switchLocks(oldTb, newTb)
        this.initialTable = clone(table)
        this.$emit('selectTable', table)
        this.$emit('recalculate')
      }
    },
    prepareCloseBalanceLogCall () {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Ispis prometa'
      req.action_id = '9'
      req.user_id = userId

      this.setLog(req)
    },
    openCloseBalanceDialog () {
      if (state.getCurrentCompany().save_log) {
        this.prepareCloseBalanceLogCall()
      }
      this.$emit('openCloseBalanceDialog')
    },
    openSearchItemsDialog () {
      this.$emit('openSearchItemsDialog')
    },
    openReceiptsDialog () {
      this.$emit('openReceiptsDialog')
    },

    getOrder () {
      const orderId = uuidv4()
      const orderItems = []

      this.data.items.forEach((item) => {
        let found = false
        if (item.notes && item.notes.length > 0) {
          if (item.notes[item.notes.length - 1].currentNote) {
            item.notes[item.notes.length - 1].orderId = orderId
            item.notes[item.notes.length - 1].currentNote = false
          }
        }

        if (this.initialTable && this.initialTable.items) {
          this.initialTable.items.forEach(initItem => {
            if (item.id === initItem.id) {
              found = true
              const quantityChanged = item.quantity !== initItem.quantity
              const discountChanged = (item.discount?.rate !== initItem.discount?.rate) ||
                (item.discount?.amount !== initItem.discount?.amount) ||
                (!!item.discount !== !!initItem.discount)

              if (quantityChanged || discountChanged) {
                const diff = item.quantity - initItem.quantity
                const itemClone = clone(item)
                itemClone.quantity = diff

                if (quantityChanged && item.newKeys && initItem.newKeys) {
                  const oldKeys = []
                  Object.keys(item.newKeys).forEach(nKey => {
                    Object.keys(initItem.newKeys).forEach(iKey => {
                      if (nKey === iKey) {
                        oldKeys.push(nKey)
                      }
                    })
                  })

                  if (oldKeys && oldKeys.length > 0) {
                    oldKeys.forEach(key => {
                      delete itemClone.choosenProductOrder[key]
                      delete itemClone.choosenTagOrder[key]
                    })
                  }
                }

                orderItems.push(itemClone)
              }
            }
          })
        }

        if (!found) {
          const itemClone = clone(item)
          orderItems.push(itemClone)
        }
      })

      if (this.initialTable && this.initialTable.items) {
        this.initialTable.items.forEach(initItem => {
          const stillExists = this.data.items.some(item => item.id === initItem.id)
          if (!stillExists) {
            const itemClone = clone(initItem)
            itemClone.quantity = -initItem.quantity
            orderItems.push(itemClone)
          }
        })
      }

      const order = {
        id: orderId,
        order_number: this.selectedTable.orders && this.selectedTable.orders.length > 0 ? this.selectedTable.orders.length + 1 : 1,
        added_by_name: state.getCashRegisterUser() && state.getCashRegisterUser().name ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname : state.getUser().name + ' ' + state.getUser().surname,
        added_by_id: state.getCashRegisterUser() && state.getCashRegisterUser().id ? state.getCashRegisterUser().id : state.getUser().id,
        order_status: 'ORDERED',
        order_items: orderItems,
        created_at: Date.now()
      }

      return order
    },
    clearOrderFromScreen () {
      this.data.items = []
      this.receiptNote = null
    },

    prepareLogCall (table, order) {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Dodavanje na stol'
      req.action_id = '4'
      req.user_id = userId

      var description = table.name
      description += '\n'

      var totalOrder = 0
      if (order.order_items.length > 0) {
        order.order_items.forEach((item, k) => {
          if (k > 0 && k < order.order_items.length) {
            description += '\n'
          }

          var price = item.unitPrice * item.quantity
          if (item.discountedUnitPrice > 0) {
            price = item.discountedUnitPrice * item.quantity
          }

          if (item.quantity > 0) {
            totalOrder += price
          }

          var formatter = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          })

          var priceFormatted = formatter.format(price / 100)
          var amt = item.quantity
          description += amt.toFixed(2).replace('.', ',') + ' x ' + item.name + ' ' + ' ' + priceFormatted
        })

        description += '\n'
      }

      var totalFormatted = (totalOrder / 100).toFixed(2).replace('.', ',')
      description += 'Ukupno narudžba: ' + totalFormatted + '€'
      req.description = description
      req.user_id = userId

      this.setLog(req)
    },
    async onSaveItemsToTable () {
      // FIX: Two scenarios:
      // 1. Normal save: cart has items → copy them to table
      // 2. Merge save: cart is empty (already cleared in onTableSelectionAddToTable) → don't copy, table already has merged items
      if (this.data.items.length > 0) {
        this.selectedTable.items = [...this.data.items]
      }

      // Check if table has items after potential copy
      if (this.selectedTable.items.length === 0) return

      this.showLoader('Spremam ' + this.selectedTable.name, { additionalTextTimer: 3500, additionalText: 'Oprostite što mi treba malo dulje, vaš internet se usporio.' })

      this.selectedTable.locked = true
      this.selectedTable.color = 'rgba(97, 84, 164, 0.95)'
      this.selectedTable.locked_by = state.getUser().id

      const timestampInSeconds = Math.floor(Date.now() / 1000)

      const order = this.getOrder()
      order.created = timestampInSeconds
      order.courses = [{
        created: timestampInSeconds,
        id: 1,
        name: 'Ostalo',
        items: order.order_items
      }]

      if (order.order_items.length === 0) {
        this.saveTable(this.selectedTable)
        this.clearOrderFromScreen()
        if (!this.selectedTables.some(tbl => tbl.id === this.selectedTable.id)) {
          this.selectedTables.push(this.selectedTable)
        }
        this.initialTable = clone(this.selectedTable)
        this.$emit('recalculate')
        this.onNewOrder()
        EventBus.$emit('table-saved-clear-pending')
        if (this.showSuccessMessageOnSave) {
          EventBus.$emit('table-saved-successfully')
          this.showSuccessMessageOnSave = false
        }
        this.$emit('resetNotes')
        this.hideLoader()
        return
      }

      if (state.getCurrentCompany().save_log) {
        this.prepareLogCall(this.selectedTable, order)
      }

      this.$emit('sendNotes', null, order)

      const userName = state.getCashRegisterUser() && state.getCashRegisterUser().name
        ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname
        : state.getUser().name + ' ' + state.getUser().surname
      const userId = state.getCashRegisterUser() && state.getCashRegisterUser().id
        ? state.getCashRegisterUser().id
        : state.getUser().id

      try {
        const mappedItems = order.order_items.map(item => {
          if (item.notes && item.notes.length > 0) {
            const lastNote = item.notes[item.notes.length - 1]
            if (lastNote && lastNote.message) {
              return { ...item, note: lastNote.message }
            }
          }
          return item
        })

        const createOrderApi = functions.httpsCallable('createorder')
        await createOrderApi({
          action: {
            resource_id: '',
            operation: 'create',
            entity: 'order',
            params: {
              items: mappedItems,
              location_id: state.getPointOfSale().id,
              table_id: this.selectedTable.id,
              user_id: userId,
              user_name: userName
            }
          }
        })

        this.clearOrderFromScreen()
        if (!this.selectedTables.some(tbl => tbl.id === this.selectedTable.id)) {
          this.selectedTables.push(this.selectedTable)
        }

        this.initialTable = clone(this.selectedTable)
        this.$emit('recalculate')
        this.onNewOrder()

        EventBus.$emit('table-saved-clear-pending')

        if (this.showSuccessMessageOnSave) {
          EventBus.$emit('table-saved-successfully')
          this.showSuccessMessageOnSave = false
        }
      } catch (err) {
        console.error('❌ Greška prilikom spremanja narudžbe:', err)
        this.confirm({
          title: 'Pogreška prilikom spremanja',
          message: 'Spremanje narudžbe nije uspjelo. Molimo ponovite.',
          options: {
            toolbar: true,
            width: 410,
            confirmText: 'Nastavi'
          }
        }).then((resp) => {})
      }

      this.$emit('resetNotes')
    },
    getOrderWithTimeout (tableId, orderId) {
      setTimeout(() => {
        return this.getLastOrderFromDb(tableId, orderId)
      }, 500)
    },
    async getLastOrderFromDb (tableId, orderId) {
      let dbOrder

      await df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tableId}`)
        .get()
        .then((tableData) => {
          const tb = tableData.data()
          if (tb && tb.orders && tb.orders.length > 0) {
            tb.orders.forEach((or, index) => {
              if (or.id === orderId) {
                dbOrder = tb.orders[index]
              }
            })
          }
        })
      return dbOrder
    },
    async prepareOrderForPrint (order, table) {
      console.log('🔴 [PanelPaymentSelection] prepareOrderForPrint CALLED', new Date().toISOString(), 'order:', order?.id, 'table:', table?.name)
      console.trace('🔴 Call stack:')
      const itemsInOrgUnits = {}
      if (order && order.order_items && order.order_items.length > 0) {
        order.order_items.forEach(item => {
          if (item.organizational_unit_id && item.organizational_unit_id !== '') {
            if (!itemsInOrgUnits[item.organizational_unit_id]) {
              itemsInOrgUnits[item.organizational_unit_id] = []
            }
            itemsInOrgUnits[item.organizational_unit_id].push(item)
          }

          if (item.choosenProductOrder) {
            Object.keys(item.choosenProductOrder).forEach(key => {
              if (item.choosenProductOrder[key] && item.choosenProductOrder[key].length > 0) {
                item.choosenProductOrder[key].forEach(product => {
                  if (product && product.productItems) {
                    product.productItems.forEach(it => {
                      if (it.org_units && it.org_units[state.getPointOfSale().id]) {
                        if (item.choosenTagOrder[key]) {
                          it.tags = item.choosenTagOrder[key]
                        }
                        it.menuId = key
                        it.menuData = {
                          productName: product.productName,
                          id: item.id,
                          name: item.name
                        }

                        if (!itemsInOrgUnits[it.org_units[state.getPointOfSale().id]]) {
                          itemsInOrgUnits[it.org_units[state.getPointOfSale().id]] = []
                        }

                        itemsInOrgUnits[it.org_units[state.getPointOfSale().id]].push(it)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        var otherUnits = []
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          this.orgUnits.forEach(orgUnit => {
            if (orgUnit.id === unitId) {
              otherUnits.push(orgUnit)
            }
          })
        })

        console.log('🔴 [PanelPaymentSelection] Processing', Object.keys(itemsInOrgUnits).length, 'organizational units')
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          const orgUnit = this.orgUnits.find(u => u.id === unitId)

          if (orgUnit) {
            const printer = this.printers.find(p =>
              p.id === orgUnit.printer || p.name === orgUnit.printer
            )

            if (printer) {
              console.log('🔴 [PanelPaymentSelection] Calling printAndSaveItems for unit:', unitId, 'printer:', printer.name)
              this.printAndSaveItems(itemsInOrgUnits[unitId], printer, orgUnit, table, order, otherUnits)
            }
          }
        })
      }
    },
    async imidiatePrintPrepare (items) {
      const itemsInOrgUnits = {}
      if (items && items.length > 0) {
        items.forEach(item => {
          if (item.organizational_unit_id && item.organizational_unit_id !== '') {
            if (!itemsInOrgUnits[item.organizational_unit_id]) {
              itemsInOrgUnits[item.organizational_unit_id] = []
            }
            itemsInOrgUnits[item.organizational_unit_id].push(item)
          }

          if (item.choosenProductOrder) {
            Object.keys(item.choosenProductOrder).forEach(key => {
              if (item.choosenProductOrder[key] && item.choosenProductOrder[key].length > 0) {
                item.choosenProductOrder[key].forEach(product => {
                  if (product && product.productItems) {
                    product.productItems.forEach(it => {
                      if (it.org_units && it.org_units[state.getPointOfSale().id]) {
                        if (item.choosenTagOrder[key]) {
                          it.tags = item.choosenTagOrder[key]
                        }
                        it.menuId = key
                        it.menuData = {
                          id: item.id,
                          name: item.name
                        }

                        if (!itemsInOrgUnits[it.org_units[state.getPointOfSale().id]]) {
                          itemsInOrgUnits[it.org_units[state.getPointOfSale().id]] = []
                        }

                        itemsInOrgUnits[it.org_units[state.getPointOfSale().id]].push(it)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        var otherUnits = []
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          this.orgUnits.forEach(orgUnit => {
            if (orgUnit.id === unitId) {
              otherUnits.push(orgUnit)
            }
          })
        })

        Object.keys(itemsInOrgUnits).forEach(unitId => {
          const orgUnit = this.orgUnits.find(u => u.id === unitId)

          if (orgUnit) {
            const printer = this.printers.find(p =>
              p.id === orgUnit.printer || p.name === orgUnit.printer
            )

            if (printer) {
              this.imidiatePrint(itemsInOrgUnits[unitId], printer, orgUnit, otherUnits)
            }
          }
        })
      }
    },
    async printAndSaveItems (items, printer, orgUnit, table, order, otherUnits) {
      console.log('🟠 [PanelPaymentSelection] printAndSaveItems CALLED', new Date().toISOString(), 'items:', items?.length, 'printer:', printer?.name)
      const orgUnitOrderId = uuidv4()
      const docRef = df.doc(`location_units/${state.getPointOfSale().id}/units/${orgUnit.id}/orders/${orgUnitOrderId}`)

      let note = null
      if (order.notes) {
        note = order.notes.find(n => n.unitId === orgUnit.id)
      }

      try {
        await docRef.set(
          {
            id: orgUnitOrderId,
            name: table && table.name ? table.name : 'Za van',
            number: order.order_number,
            order_added_by: state.getCashRegisterUser() ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname : state.getUser().name + ' ' + state.getUser().surname,
            items: items,
            printer_address: printer.ip_address
          }
        )
      } catch (err) {
        console.error('Error saving order: ', err)
      }

      console.log('🟠 [PanelPaymentSelection] About to call printOrder...')
      state.setPosPrinterSettings(2)

      try {
        const result = await printOrder(items, printer, table, order, orgUnit, otherUnits, note, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }
      } catch (err) {
        console.error('❌ [PanelPaymentSelection] Print failed:', err)

        // Show error to user with retry option
        EventBus.$emit('show-message-box', {
          title: 'Greška pri printanju',
          text: `Narudžba nije printana: ${err.message}. Želite li pokušati ponovno?`,
          actions: ['confirm', 'cancel'],
          confirmText: 'Pokušaj ponovno',
          cancelText: 'Odustani',
          color: 'error'
        })

        // Listen for retry - remove any existing listeners first
        EventBus.$off('message-box-confirm')
        EventBus.$once('message-box-confirm', async () => {
          await this.retryPrint(items, printer, orgUnit, table, order, otherUnits, note)
        })
      }
    },
    async retryPrint (items, printer, orgUnit, table, order, otherUnits, note, attempt = 1, maxAttempts = 3) {
      console.log(`🔄 [PanelPaymentSelection] Retry attempt ${attempt}/${maxAttempts}`)

      try {
        const result = await printOrder(items, printer, table, order, orgUnit, otherUnits, note, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }

        // Success!
        EventBus.$emit('show-message-box', {
          text: '✅ Narudžba uspješno printana!',
          actions: ['cancel'],
          cancelText: 'OK',
          color: 'success'
        })
      } catch (err) {
        if (attempt < maxAttempts) {
          // Wait 2 seconds and retry
          await new Promise(resolve => setTimeout(resolve, 2000))
          await this.retryPrint(items, printer, orgUnit, table, order, otherUnits, note, attempt + 1, maxAttempts)
        } else {
          // Max attempts reached
          EventBus.$emit('show-message-box', {
            title: 'Printanje neuspješno',
            text: `Pokušano ${maxAttempts}x, ali printing nije uspio. Provjerite printer i pokušajte ponovno kasnije.`,
            actions: ['cancel'],
            cancelText: 'OK',
            color: 'error'
          })
        }
      }
    },
    async imidiatePrint (items, printer, orgUnit, otherUnits) {
      state.setPosPrinterSettings(2)

      try {
        const result = await printOrder(items, printer, undefined, undefined, orgUnit, otherUnits, undefined, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }
      } catch (err) {
        console.error('❌ [PanelPaymentSelection] Immediate print failed:', err)

        // Show error notification
        EventBus.$emit('show-message-box', {
          title: 'Greška pri printanju',
          text: `Narudžba nije printana: ${err.message}`,
          actions: ['cancel'],
          cancelText: 'OK',
          color: 'error'
        })
      }
    },
    saveItemsToDatabase (table, persist) {
      this.saveTable(table, persist)
    },
    orderHasChanged () {
      if (this.selectedTable.id && this.data.items && this.data.items.length > 0) {
        let itemCountDifferent = false
        const lengthDifferent = this.selectedTable.items.length !== this.data.items.length
        for (let i = 0; i < this.selectedTable.items.length; i++) {
          const tableItem = this.selectedTable.items[i]
          const cartItem = this.data.items.find(i => i.id === tableItem.id)
          if (tableItem && cartItem && tableItem.quantity !== cartItem.quantity) {
            itemCountDifferent = true
            break
          }
        }
        return itemCountDifferent || lengthDifferent
      }
    },
    onTableCellClick (table, closeDialog = false) {
      if (closeDialog) {
        this.showTbls = false
      }
      if ((!this.selectedTable.id && this.data.items && this.data.items.length > 0) || this.orderHasChanged()) {
        // Show custom dialog with two options: Delete order or Add to table
        this.pendingTable = table
        this.tableSelectionDialogOpen = true
      } else {
        if (table.locked && table.locked_by !== state.getUser().id) {
          this.confirm({
            title: this.$t('$vuetify.tables.unlockTitle'),
            message: `${table.name} ${this.$t('$vuetify.tables.unlockMessageOther')}`,
            options: {
              toolbar: true,
              width: 410,
              confirmText: this.$t('$vuetify.yes'),
              cancelText: this.$t('$vuetify.no')
            }
          }).then(async (resp) => {
            if (resp) {
              if (this.selectedTable.number > 0) {
                df.doc(`location_orders/${state.getPointOfSale().id}/tables/${this.selectedTable.id}`).update({ locked: false, color: 'primary', locked_by: state.getUser().id })
              }

              this.selectedTable = table
              if (table.receiptNote && table.receiptNote.note !== '') {
                this.receiptNote = { note: table.receiptNote.note }
              }
              this.$emit('clearInvoice', table)
              df.doc(`location_orders/${state.getPointOfSale().id}/tables/${table.id}`).update({ locked: true, color: 'rgba(97, 84, 164, 0.95)', locked_by: state.getUser().id })
                .catch((err) => {
                  console.error(err)
                  this.showMsgBox({ text: `Pogreška prilikom otključavanja: ${err}`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
                })
            }
            this.confirmClose()
          })
        } else if (!this.editMode) {
          this.receiptNote = { note: table.receiptNote?.note ? table.receiptNote?.note : '' }
          this.selectTable(table)
        }
      }
    },

    selectTable (table) {
      const tb = clone(table)
      this.onSelectTable(tb)
      this.$emit('recalculate')
    },

    /**
     * Merge cart items with table items
     * If item already exists on table, increase quantity
     * Otherwise, add new item to table
     */
    mergeCartItemsWithTable (table, onlyPending = false) {
      const tableItems = table.items || []
      const cartItems = this.data.items || []
      const originalTableItems = this.selectedTable.items || []

      // Create a copy of table items to work with
      const mergedItems = [...tableItems]

      // If onlyPending, only merge new/changed items (pending items)
      if (onlyPending) {
        cartItems.forEach(cartItem => {
          // Find if item existed on original table
          const originalItem = originalTableItems.find(item => item.id === cartItem.id)

          if (originalItem) {
            // Item existed - check if quantity increased
            const quantityDiff = (cartItem.quantity || 0) - (originalItem.quantity || 0)
            if (quantityDiff > 0) {
              // Quantity increased - add only the difference
              const existingItem = mergedItems.find(item => item.id === cartItem.id)
              if (existingItem) {
                existingItem.quantity = (existingItem.quantity || 0) + quantityDiff
                existingItem.total = existingItem.unitPrice * existingItem.quantity
              } else {
                // Item not on target table yet, add with diff quantity
                const newItem = clone(cartItem)
                newItem.quantity = quantityDiff
                newItem.total = newItem.unitPrice * quantityDiff
                mergedItems.push(newItem)
              }
            }
          } else {
            // Item is completely new - add it
            const existingItem = mergedItems.find(item => item.id === cartItem.id)
            if (existingItem) {
              existingItem.quantity = (existingItem.quantity || 0) + (cartItem.quantity || 0)
              existingItem.total = existingItem.unitPrice * existingItem.quantity
            } else {
              mergedItems.push(clone(cartItem))
            }
          }
        })
      } else {
        // Original behavior - merge all cart items
        cartItems.forEach(cartItem => {
          const existingItem = mergedItems.find(item => item.id === cartItem.id)

          if (existingItem) {
            // Item exists on table, increase quantity
            existingItem.quantity = (existingItem.quantity || 0) + (cartItem.quantity || 0)
            existingItem.total = existingItem.unitPrice * existingItem.quantity
          } else {
            // Item doesn't exist on table, add it
            mergedItems.push(clone(cartItem))
          }
        })
      }

      return mergedItems
    },

    /**
     * Handle table selection dialog - Cancel button
     */
    onTableSelectionCancel () {
      this.tableSelectionDialogOpen = false
      this.pendingTable = null
    },

    /**
     * Handle table selection dialog - Delete order button
     * Clear cart and select the table
     */
    onTableSelectionDeleteOrder () {
      const table = this.pendingTable
      this.tableSelectionDialogOpen = false
      this.pendingTable = null

      // Clear cart and select table
      this.data.items = []
      this.receiptNote = { note: table.receiptNote?.note ? table.receiptNote?.note : '' }
      this.selectTable(table)
    },

    /**
     * Handle table selection dialog - Add to table button
     * Merge cart items with table items and automatically save to table
     */
    onTableSelectionAddToTable () {
      const table = this.pendingTable
      this.tableSelectionDialogOpen = false
      this.pendingTable = null

      // ✅ FIX: Save OLD table state as initialTable BEFORE merging
      // This way getOrder() can detect new items by comparing with old state
      this.initialTable = clone(table)

      // Merge only pending (new) cart items with table items
      const mergedItems = this.mergeCartItemsWithTable(table, true)
      table.items = mergedItems

      // Clear cart and select table with merged items
      this.data.items = []
      this.receiptNote = { note: table.receiptNote?.note ? table.receiptNote?.note : '' }

      // ✅ FIX: Don't call selectTable here - it would overwrite initialTable with merged items!
      // Instead, just set selectedTable directly
      this.selectedTable = table
      this.$emit('selectTable', table)
      this.$emit('recalculate')

      // Set flag to show success message after save
      this.showSuccessMessageOnSave = true

      // Automatically save the merged items to the table
      this.$nextTick(() => {
        this.onSaveItemsToTable()
      })
    },
    async onNewOrder () {
      this.receiptNote = null
      if (this.selectedTable.id && !this.orderHasChanged()) {
        await this.createNewOrder(true)
      }

      if ((!this.selectedTable.id && this.data.items && this.data.items.length > 0) || this.orderHasChanged()) {
        this.confirm({
          title: this.$t('$vuetify.tables.note'),
          message: this.$t('$vuetify.tables.noteMessage'),
          options: {
            toolbar: true,
            width: 410,
            confirmText: this.$t('$vuetify.tables.continue'),
            cancelText: this.$t('$vuetify.tables.cancel')
          }
        }).then(async (resp) => {
          if (resp) {
            await this.createNewOrder(false)
          }
          this.confirmClose()
        })
      }

      this.hideLoader()
    },
    async createNewOrder (tableSelected) {
      if (tableSelected) {
        await df.doc(`location_orders/${state.getPointOfSale().id}/tables/${this.selectedTable.id}`).update({ locked: false, color: 'primary' })
      }
      this.selectedTable = new Table()
      this.clearOrderFromScreen()
      this.$emit('selectTable', this.selectedTable)
      this.$emit('recalculate')
    },
    onClearOrder () {
      this.confirm({
        title: 'Ukloni narudžbu',
        message: `${this.$t('$vuetify.tables.clearOrder')} ${this.selectedTable.number}?</br></br> ${this.$t('$vuetify.tables.note')} </br> Svako brisanje narudžbe će biti zabilježeno.`,
        options: {
          toolbar: true,
          width: 410,
          confirmText: this.$t('$vuetify.yes'),
          cancelText: this.$t('$vuetify.no')
        }
      }).then(async (resp) => {
        if (resp) {
          this.confirmClose()
          this.removeOrderFromTable()
        }
      })
    },
    async removeOrderFromTable (paymentDone = false) {
      // Save table reference before clearing
      var tbl = clone(this.selectedTable)

      // this.selectedTable.items = []
      this.initialTable.items = []
      const tblIndex = this.selectedTables.findIndex((tbl) => tbl.number === this.selectedTable.number)
      if (tblIndex > -1) {
        this.selectedTable.items = []
        this.selectedTable.locked = false
        this.selectedTable.locked_by = ''
        this.selectedTables.splice(tblIndex, 1)
        this.selectedTable.orders = []
      }

      // Always call emptyTable to update Firebase, regardless of whether table was in array
      if (tbl && tbl.id) {
        await this.emptyTable(tbl, paymentDone)
      }

      if (!tbl.persistent) {
        await this.deleteTable(tbl)
      }
      this.clearOrderFromScreen()
      this.data.total = 0
      this.data.fullTotal = 0
      this.data.totalWithDiscount = 0
      this.data.totalShoppingCart = 0
      this.data.discount = undefined
      this.selectedTable = new Table()
      this.$emit('clearSelection')
      this.$emit('recalculate')
      this.hideLoader()
    },
    onR1DialogClose () {
      this.r1DialogOpen = false
    },

    getTables () {
      const query = df.collection(`location_orders/${state.getPointOfSale().id}/tables`).orderBy('number')
      const listener = query.onSnapshot((doc) => {
        const tmpSelectedTables = [...this.selectedTables]

        this.selectedTables = this.selectedTables.filter(table => table.type !== 'tableDialogOpener')
        this.selectedTables.unshift({ name: 'gumb', type: 'tableDialogOpener', action: 'openTables' })

        doc.docChanges().forEach((change) => {
          const table = change.doc.data()
          if (change.type === 'added') {
            if (table && table.items && table.items.length > 0 && ((this.manager) || (table.user_id && table.user_id === this.userId))) {
              this.selectedTables.push(table)
            }
          } else if (change.type === 'modified') {
            this.selectedTables = []
            this.selectedTables.unshift({ name: 'gumb', type: 'tableDialogOpener', action: 'openTables' })

            if (table.locked_by !== state.getUser().id) {
              this.$emit('clearInvoice', new Table())
            }
            doc.docs.forEach((rec) => {
              let modTbl = rec.data()
              if (rec.data().id === table.id) {
                modTbl = table
              }
              if (modTbl && modTbl.items && modTbl.items.length > 0 && ((this.manager) || (modTbl.user_id && modTbl.user_id === this.userId))) {
                this.selectedTables.push(modTbl)
              }
            })
          }
        })

        if (this.selectedTables.length === 0) {
          this.selectedTables = [...tmpSelectedTables]
        }

        this.availableTables = []
        doc.docs.forEach((rec) => {
          const table = rec.data()
          const availableIndex = this.availableTables.findIndex((tbl) => tbl.id === table.id)
          if (availableIndex > -1) {
            this.availableTables.splice(availableIndex, 1, table)
          } else {
            this.availableTables.push(table)
          }
        })
      })

      this.listeners.push(listener)
    },

    async updateTable (table) {
      var tbl = this.selectedTables.find(t => t.id === table.id)

      if (!tbl) {
        tbl = this.availableTables.find(t => t.id === table.id)
      }
      if (tbl) {
        var receiptNote = clone(this.receiptNote)
        this.receiptNote = null

        return df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tbl.id}`).update({
          items: table.items,
          user_id: this.userId,
          user_name: this.user.name + ' ' + this.user.surname,
          update_time: Date.now(),
          receiptNote: receiptNote || ''
        })
          .then(() => {
            console.info('Table succesfully updated.')
          })
          .catch(() => {
            console.error('Table has not been updated succesfully.')
          })
      }
    },
    async addSplitTable (table, sourceTable) {
      const numberOfTables = this.selectedTables.filter(t => t.name.startsWith(this.selectedTable.name))
      this.tableNameSuffix = numberOfTables.length + 1
      const tbl = {
        color: table.color,
        id: uuidv4(),
        locked: false,
        locked_by: state.getUser().id,
        number: this.getCurrentTableNumber() + 1,
        name: `${sourceTable.name}/${this.tableNameSuffix}`,
        persistent: false,
        items: table.items,
        user_id: this.userId,
        user_name: this.user.name + ' ' + this.user.surname,
        update_time: Date.now()
      }
      const docRef = df.collection(`location_orders/${state.getPointOfSale().id}/tables`)

      try {
        await docRef.doc(tbl.id).set(tbl)
        console.info('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },
    getCurrentTableNumber () {
      if (this.availableTables.length === 0) {
        return 0
      }
      return Math.max(...this.availableTables.map(table => table.number))
    },

    async saveTable (table, persist, newTable = false) {
      let tblId, persistent, items
      if (table.id && table.id === this.selectedTable.id) {
        tblId = table.id
      } else {
        tblId = uuidv4()
        table.id = tblId
      }
      if (persist !== undefined) { persistent = persist } else { persistent = this.selectedTable.persistent }
      if (table.items.length > 0) { items = [...table.items] } else { items = [] }
      const docRef = df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tblId}`)

      var receiptNote = ''
      if (newTable === false) {
        receiptNote = clone(this.receiptNote)
        this.receiptNote = null
      }

      var newItems = []
      items.forEach(item => {
        if (item instanceof WriteInProductModel) {
          var price = item.prices.EUR.price

          var newItem = {
            active: item.active,
            barcode: item.barcode,
            categories: item.categories,
            category_ids: item.category_ids,
            code: item.code,
            created: item.created,
            description: item.description,
            id: item.id,
            manual_price_input: item.manual_price_input,
            discountedUnitPrice: price,
            fullTotal: price,
            total: price,
            unitPrice: price,
            name: item.name,
            menu: item.menu,
            picture: item.picture,
            prices: item.prices,
            quantity: item.quantity,
            selling_unit: item.selling_unit,
            sold_count: item.sold_count,
            status: item.status,
            stock: item.stock,
            storage_unit: item.storage_unit,
            suppliers: item.suppliers,
            type: item.type
          }

          // TODO maknuti ako ne bude trebalo
          // var unitID = 'unit_1'
          // newItem.warehouse_units = {
          //   base_unit: unitID,
          //   default_sale: unitID,
          //   default_store: unitID,
          //   units: {
          //     unit_1: {
          //       id: unitID,
          //       base_unit: true,
          //       default_sale: true,
          //       default_store: true,
          //       is_selling_item: true,
          //       prices: {
          //         EUR: {
          //           active: true,
          //           base: 0,
          //           price: item.prices.EUR.price,
          //           taxes: item.prices.EUR.taxes

          //         }
          //       },
          //       storage_amount: 1000,
          //       storage_unit: item.selling_unit
          //     }
          //   }
          // }
          newItems.push(newItem)
        } else {
          newItems.push(item)
        }
      })

      var params = {
        id: tblId,
        name: table.name,
        number: table.number,
        items: newItems,
        persistent: persistent,
        color: table.color ? table.color : '',
        locked: table.locked ? table.locked : false,
        locked_by: state.getUser().id,
        orders: table.orders && table.orders.length > 0 ? table.orders : [],
        user_id: this.userId,
        user_name: this.user.name + ' ' + this.user.surname,
        update_time: Date.now(),
        receiptNote: receiptNote || ''
      }
      if (this.data.discount) {
        params.discount = this.data.discount
      }

      try {
        await docRef.set(params, { merge: true })
        console.info('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },
    prepareLogCallDelete (table) {
      var req = new LogData()

      let userId = auth.currentUser.uid
      if (state.getCashRegisterUser().id && state.getCashRegisterUser().id !== '') {
        userId = state.getCashRegisterUser().id
      }

      req.action_name = 'Brisanje stola'
      req.action_id = '3'
      req.user_id = userId

      var description = table.name
      description += '\n'

      var totalTable = 0
      if (table.items && table.items.length > 0) { // Dodana provjera za table.items
        table.items.forEach((item, k) => {
          // Dodaj novi red prije svakog artikla osim prvog
          if (k > 0) {
            description += '\n'
          }

          // Osiguraj da je 'price' broj, inače koristi 0
          const price = Number(item.total) || 0
          totalTable += price

          const formatter = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          })

          const priceFormatted = formatter.format(price / 100)

          // Pokušaj pretvoriti item.quantity u broj
          const amt = Number(item.quantity)

          // Provjeri je li 'amt' valjan broj prije poziva toFixed
          if (!isNaN(amt)) {
            description += amt.toFixed(2).replace('.', ',') + ' x ' + (item.name || 'Nepoznat artikl') + ' ' + priceFormatted
          } else {
            // Ovdje možeš odlučiti što napraviti ako količina nije valjan broj
            // Npr. ispisati upozorenje ili koristiti zadanu vrijednost
            console.warn(`Artikl ${item.name || item.id} ima neispravnu količinu: ${item.quantity}`)
            description += `? x ${item.name || 'Nepoznat artikl'} ${priceFormatted}` // Primjer s upitnikom
          }
        })
      }

      var totalFormatted = (totalTable / 100).toFixed(2).replace('.', ',')
      description += '\nUkupan iznos stola: ' + totalFormatted + '€'
      req.description = description
      req.user_id = userId

      this.setLog(req)
    },

    async emptyTable (table, paymentDone = false) {
      if (state.getCurrentCompany().save_log && !paymentDone) {
        this.prepareLogCallDelete(table)
      }

      var deleteTable = clone(table)
      var id = uuidv4()
      var time = new Date()
      deleteTable.delete_time = time.getTime()
      deleteTable.delete_time_readable = 'Datum: ' + ('0' + time.getDate()).slice(-2) + '.' + ('0' + (time.getMonth() + 1)).slice(-2) + '.' + time.getFullYear() + ', ' + 'Vrijeme: ' + ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2)
      deleteTable.history_id = id
      var docRef = df.doc(`location_orders_history/${state.getPointOfSale().id}/tables/${id}`)

      try {
        await docRef.set(deleteTable)
        console.info('Document successfully saved.')
      } catch (err) {
        console.error('Error saving document: ', err)
      }

      docRef = df.doc(`location_orders/${state.getPointOfSale().id}/tables/${table.id}`)
      try {
        await docRef.set(
          {
            id: table.id,
            name: table.name,
            number: table.number,
            items: [],
            persistent: table.persistent,
            color: 'primary',
            locked: false,
            locked_by: '',
            mark_for_delete: true,
            update_time: 0,
            user_id: '',
            user_name: ''
          }
        )
        console.info('Table successfully emptied.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },

    onDeleteTable (table) {
      this.deleteTable(table)
    },

    async deleteTable (table) {
      var docRef = df.doc(`location_orders_history/${state.getPointOfSale().id}/tables/${table.id}/history/${new Date().getTime()}`)
      var tableRef = df.doc(`location_orders_history/${state.getPointOfSale().id}/tables/${table.id}`)

      try {
        await tableRef.set({ id: table.id })
        await docRef.set(table)
        console.info('Document successfully saved.')
      } catch (err) {
        console.error('Error saving document: ', err)
      }

      docRef = df.doc(`location_orders/${state.getPointOfSale().id}/tables/${table.id}`)
      try {
        await docRef.delete()
        console.info('Document successfully deleted.')
        if (table.id === this.selectedTable.id) {
          this.selectedTable = new Table()
        }
      } catch (err) {
        console.error('Error deleteing document: ', err)
      }
    },

    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    },
    setDefaults () {
      this.languages = [
        { name: this.$t('$vuetify.receiptLanguages.hr'), value: 'hr' },
        { name: this.$t('$vuetify.receiptLanguages.en'), value: 'en' }
      ]
      this.language = this.languages[0]
      this.maxIssueDate = toISOLocal(new Date())
      this.issueDate = ''
    },

    detachListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    },

    dateTimeToUnixTimestamp (dt) {
      return Math.floor(new Date(toISOLocal(dt)).getTime() / 1000)
    },
    insertAccountDetails (method, receiptType, deliveryName = undefined, paymentCard = undefined) {
      if (receiptType === 'R') {
        if (paymentCard && paymentCard.name && paymentCard.name !== '') {
          this.selectedCard = paymentCard
        }
        this.paymentMethod = method
        this.r1DialogOpen = true
      }
    },
    onAccountDetailsFinishPayment (data) {
      this.type = data.type
      this.paymentReference = data.pnb ? data.pnbModel + ' ' + data.pnb : ''

      if (data.selectedCostCenter) {
        this.selectedCostCenter = data.selectedCostCenter
      }

      var selectedCard = this.selectedCard
      var selectedTerminal = this.selectedTerminal
      this.finishPayment(this.paymentMethod, 'R', undefined, selectedCard, selectedTerminal)
    },

    /// FINISH PAYMENT
    async finishPayment (method, receiptType, deliveryName = undefined, paymentCard = undefined, terminal = undefined) {
      // CRITICAL: Prevent double receipt creation
      if (this.isProcessingPayment) {
        return
      }

      this.isProcessingPayment = true

      if ((state.getCashRegister().type === 'MP' || state.getCashRegister().type === 'ALL') && (method === 'T' || method === 'V' || method === 'P') && this.data.discount && this.data.discount.amount > 0) {
        var type = 'Transakcijski račun'
        if (method === 'V') {
          type = 'Virman'
        }
        if (method === 'P') {
          type = 'Ponuda'
        }

        this.showMsgBox({
          title: type,
          text: type + ' se ne može izdati sa popustom na račun. Ukoliko želite nastaviti zamijenite popust na iznos sa popustom na artikle.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })

        return
      }
      if (this.selectedTable === undefined || this.selectedTable.id === '') {
        this.imidiatePrintPrepare(this.data.items)
      }

      var currency = 'HRK'
      if (Date.now() / 1000 > 1672527599) {
        currency = 'EUR'
      }

      if (receiptType === 'REPREZENTACIJA') {
        var reprezentacijaAmount = 200
        if (Date.now() / 1000 > 1672527599) {
          reprezentacijaAmount = 50
        }
        this.showLoader(this.$options.filters.money(reprezentacijaAmount, 100, currency), { opacity: 1 })
      } else {
        this.showLoader(this.$options.filters.money(this.data.total, 100, currency), { opacity: 1 })
      }

      let entity = 'receipt'

      if (method === 'V') {
        entity = 'virman'
      }

      var flag = 'BO'
      var fiscalize = true
      var offer = false
      if (method === 'P') {
        flag = 'P'
        entity = 'offer'
        offer = true
      }

      try {
        const items = await remapItems(this.data, method)
        const paymentMethod = getPaymentMethod(method)

        switch (paymentMethod) {
          case 'NOVČANICE':
            fiscalize = true
            break
          case 'KARTICA':
            fiscalize = true
            break
          case 'OSTALO':
            fiscalize = true
            break
          case 'TRANSAKCIJSKI RAČUN':
            fiscalize = false
            break
        }

        const args = {
          entity: entity,
          paymentMethod: paymentMethod,
          paymentReference: this.paymentReference ?? '',
          language: this.language,
          fiscalize: fiscalize,
          type: { flag: flag }
        }

        if (this.type) {
          args.type = clone(this.type)
          this.type = ''
        }

        // Reserve receipt number atomically (only once!)
        let reservedReceiptNumber
        try {
          reservedReceiptNumber = await this.getCashRegisterNumber(receiptType, offer)
        } catch (err) {
          this.hideLoader()
          this.isProcessingPayment = false
          EventBus.$emit('showError', { message: err })
          return
        }

        args.receiptNumber = reservedReceiptNumber

        let payload = await getPayload(this.data, items, args, state, this.receiptNote)
        if (entity === 'virman') {
          payload = await getVirmanPayload(this.data, items, args, state, this.receiptNote)
        }

        if (terminal) {
          payload.terminal = terminal
        }

        const httpArgs = {
          issueDateTime: this.dateTimeToUnixTimestamp(new Date()),
          paymentMeth: paymentMethod,
          language: this.language,
          type: this.type,
          receiptNumber: reservedReceiptNumber, // Use the same reserved number
          openPdfPrint: this.openPdfPrint,
          hideLoader: this.hideLoader,
          removeOrderFromTable: this.removeOrderFromTable,
          fiscalize: fiscalize
        }

        if (this.selectedCostCenter && this.selectedCostCenter.id !== -1) {
          httpArgs.costCenter = this.selectedCostCenter
        }

        if (receiptType && receiptType !== '') {
          switch (receiptType) {
            case 'REPREZENTACIJA':
              httpArgs.reprezentacija = true
              break
            case 'DELIVERY':
              httpArgs.delivery = true
              httpArgs.deliveryName = deliveryName
              break
          }
        }

        if (paymentCard && paymentCard.type && paymentCard.type !== '') {
          httpArgs.paymentCard = paymentCard.type
        }

        if (paymentCard && paymentCard.name && paymentCard.name !== '') {
          httpArgs.paymentCard = paymentCard.name
        }

        httpArgs.msgBox = this.showMsgBox
        httpArgs.confirm = this.confirm
        httpArgs.confirmClose = this.confirmClose

        const additionalData = {
          callNewPrint: true
        }

        // CRITICAL: Check if this receipt number is already being sent
        if (this.processingReceiptNumbers.has(reservedReceiptNumber)) {
          console.error('❌ DUPLI POZIV DETEKTIRAN! Račun broj', reservedReceiptNumber, 'već je poslan!')
          this.hideLoader()
          this.isProcessingPayment = false
          this.showMsgBox({
            title: 'Dupli poziv detektiran',
            text: `Račun broj ${reservedReceiptNumber} već je poslan na backend. Molimo pričekajte.`,
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'warning'
          })
          return
        }

        // Send the request
        if (entity === 'virman') {
          sendVirmanHttp(this.data, items, payload, httpArgs, this.selectedPrinter, additionalData)
        } else {
          sendHttp(this.data, items, payload, httpArgs, this.selectedPrinter, additionalData)
        }

        // Mark receipt number as sent (after sendHttp is called)
        this.processingReceiptNumbers.add(reservedReceiptNumber)
        console.log('✅ Račun broj', reservedReceiptNumber, 'poslan - dodan u Set. Trenutno u obradi:', Array.from(this.processingReceiptNumbers))

        this.receiptNote = null
        this.setDefaults()
      } catch (err) {
        this.hideLoader()
        this.isProcessingPayment = false
        // Clean up processing receipt number on error
        if (reservedReceiptNumber) {
          this.processingReceiptNumbers.delete(reservedReceiptNumber)
          console.log('✅ Račun broj', reservedReceiptNumber, 'uklonjen iz Set-a (catch greška). Preostalo:', Array.from(this.processingReceiptNumbers))
        }
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
      }
    },

    async getCashRegisterNumber (receiptType, offer = false) {
      var cashRegister = await retry(this.getCashRegister, 3)

      if (!cashRegister) {
        return
      }

      if (offer === true) {
        return cashRegister.offer_sequence + 1
      } else {
        return cashRegister.bill_sequence + 1
      }
    },

    async getCashRegister () {
      const response = await df.doc(`cash_registers/${state.getCashRegister().id}`).get()
      if (!response.data()) {
        throw new Error('Nije moguće dohvatiti podatke o blagajni')
      } else {
        return response.data()
      }
    },

    setupTableContainer () {
      const ele = document.getElementById('container')
      if (ele) {
        let pos = { top: 0, left: 0, x: 0, y: 0 }
        const mouseDownHandler = function (e) {
          ele.style.cursor = 'grabbing'
          ele.style.userSelect = 'none'
          pos = {
            // The current scroll
            left: ele.scrollLeft,
            top: ele.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY
          }
          const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x
            const dy = e.clientY - pos.y

            // Scroll the element
            ele.scrollTop = pos.top - dy
            ele.scrollLeft = pos.left - dx
          }
          const mouseUpHandler = function () {
            document.removeEventListener('pointermove', mouseMoveHandler)
            document.removeEventListener('pointerup', mouseUpHandler)

            ele.style.cursor = 'grab'
            ele.style.removeProperty('user-select')
          }

          document.addEventListener('pointermove', mouseMoveHandler)
          document.addEventListener('pointerup', mouseUpHandler)
        }

        document.addEventListener('pointerdown', mouseDownHandler)
      }
    },
    resetTables () {
      const interval = setInterval(() => {
        if (this.selectedTables.length > 0) {
          clearInterval(interval)
          if (this.selectedTable.number === 0) {
            this.selectedTables.forEach((t) => {
              if (t.locked && t.locked_by === state.getUser().id) {
                df.doc(`location_orders/${state.getPointOfSale().id}/tables/${t.id}`).update({ color: 'primary', locked: false })
                  .catch((err) => {
                    console.error(err)
                    this.showMsgBox({ text: `Pogreška prilikom resetiranja: ${err}`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
                  })
              }
            })
          }
        }
      }, 100)
    },
    getCards () {
      const that = this

      df
        .doc(`company_cards/${state.getCurrentCompany().id}`)
        .onSnapshot((doc) => {
          if (
            doc &&
            doc.data() &&
            doc.data().cards &&
            doc.data().cards.length > 0
          ) {
            that.availableCards = doc.data().cards.filter(card => card.active === true)
          }
          that.availableCards = that.availableCards.sort((a, b) => a.name.localeCompare(b.name))
        })
    },
    onAccountDetailsPreviewReceipt (data) {
      this.showPreview = false
      this.type = data.type
      this.type.flag = this.previewReceiptType
      this.previewReceipt(this.paymentMethod, this.previewReceiptType)
    },
    insertPreviewAccountDetails (method, receiptType) {
      if (receiptType === 'R' || receiptType === 'P') {
        this.previewReceiptType = receiptType
        this.paymentMethod = method
        this.showPreview = true
        this.r1DialogOpen = true
      }
    },
    changeWindowWidth () {
      if (window.innerWidth <= 1400) {
        this.smallWindow = true
      } else {
        this.smallWindow = false
      }
    },
    async previewReceipt (method, receiptType) {
      if ((state.getCashRegister().type === 'MP' || state.getCashRegister().type === 'ALL') && (method === 'T' || method === 'V' || method === 'P') && this.data.discount && this.data.discount.amount > 0) {
        var type = 'Transakcijski račun'
        if (method === 'V') {
          type = 'Virman'
        }

        if (method === 'P') {
          type = 'Ponuda'
        }

        this.showMsgBox({
          title: type,
          text: type + ' se ne može izdati sa popustom na račun. Ukoliko želite nastaviti zamijenite popust na iznos sa popustom na artikle.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })

        return
      }

      if (!this.data.items || this.data.items.length === 0) {
        this.showMsgBox({
          text: 'Trenutna košarica ne sadrži artikle, molimo dodajte artikle kako bi pokrenuli pregled računa.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })

        return
      }
      var deliveryName

      var data = clone(this.data)

      var currency = 'HRK'
      if (Date.now() / 1000 > 1672527599) {
        currency = 'EUR'
      }

      if (receiptType === 'REPREZENTACIJA') {
        var reprezentacijaAmount = 200
        if (Date.now() / 1000 > 1672527599) {
          reprezentacijaAmount = 50
        }
        this.showLoader(this.$options.filters.money(reprezentacijaAmount, 100, currency), { opacity: 1 })
      } else {
        this.showLoader(this.$options.filters.money(data.total, 100, currency), { opacity: 1 })
      }

      var flag = 'BO'
      let entity = 'receipt_preview'
      var offer = false
      if (method === 'V') {
        flag = 'V'
        method = 'T'
        entity = 'virman_preview'
      }
      if (receiptType === 'P') {
        flag = 'P'
        entity = 'offer_preview'
        offer = true
      }

      const fiscalize = true

      try {
        const items = await remapItems(data)
        const paymentMethod = getPaymentMethod(method)

        const args = {
          entity: entity,
          paymentMethod: paymentMethod,
          paymentReference: this.paymentReference ?? '',
          language: this.language,
          fiscalize: fiscalize,
          type: { flag: flag }
        }

        if (this.type) {
          args.type = clone(this.type)
          this.type = ''
        }

        // Reserve receipt number atomically (only once!)
        let reservedReceiptNumber
        try {
          reservedReceiptNumber = await this.getCashRegisterNumber(receiptType, offer)
        } catch (err) {
          this.hideLoader()
          EventBus.$emit('showError', { message: err })
          return
        }

        args.receiptNumber = reservedReceiptNumber

        let payload = await getPayload(data, items, args, state, this.receiptNote)
        if (entity === 'virman_preview') {
          payload = await getVirmanPayload(data, items, args, state, this.receiptNote)
        }

        const httpArgs = {
          issueDateTime: this.dateTimeToUnixTimestamp(new Date()),
          paymentMeth: paymentMethod,
          language: this.language,
          type: this.type,
          receiptNumber: reservedReceiptNumber, // Use the same reserved number
          openPdfPrint: this.openPdfPrint,
          hideLoader: this.hideLoader
        }

        if (receiptType && receiptType !== '') {
          switch (receiptType) {
            case 'REPREZENTACIJA':
              httpArgs.reprezentacija = true
              break
            case 'DELIVERY':
              httpArgs.delivery = true
              httpArgs.deliveryName = deliveryName
              break
          }
        }

        httpArgs.msgBox = this.showMsgBox

        sendPreview(data, items, payload, httpArgs, this.selectedPrinter)
      } catch (err) {
        this.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
      }
    },
    getWholesaleItem (item) {
      const newItem = clone(item)
      var pnpAmt = 0
      if (newItem.pnp && newItem.pnp !== null && newItem.pnp.rate && newItem.pnp.rate > 0) {
        pnpAmt = newItem.pnp.rate
      }

      var taxes = newItem.pdv.rate + pnpAmt

      newItem.price =
        Math.round(parseFloat(newItem.price / (1 + taxes / 10000)), 2)

      newItem.single_item_price =
        Math.round(parseFloat(newItem.single_item_price / (1 + taxes / 10000)), 2)

      return newItem
    }

  },

  created () {
    this.user = state.getCashRegisterUser().id ? state.getCashRegisterUser() : state.getUser()
    this.userId = this.user.id
    this.manager = !!(this.user.roles && this.user.roles.VODITELJ && this.user.roles.VODITELJ === true)
    this.selectedTable = new Table()
    this.getTables()
    this.resetTables()
    this.tooltipDelay = state.getTooltipDelay()
    this.loadFloorPlanSetting() // Keep for backward compatibility

    // Load new table settings (with migration support)
    this.loadTableSettings()

    // Initialize payment methods configuration from state
    this.localEnabledPaymentMethods = state.getEnabledPaymentMethods()

    // Listen for payment methods configuration updates
    this.$root.$on('payment-methods-updated', () => {
      // Update local copy to trigger reactivity
      this.localEnabledPaymentMethods = { ...state.getEnabledPaymentMethods() }
    })
  },

  mounted () {
    this.changeWindowWidth()
    window.addEventListener('resize', this.changeWindowWidth)
    document.addEventListener('keydown', this.handleButtonKeyPress)
    this.getCards()
    this.data.currency = 'HRK'
    if (Date.now() / 1000 > 1672527599) {
      this.data.currency = 'EUR'
    }

    this.selectedCard = undefined
    this.setupTableContainer()

    // Listen for table transfer starting event (za overlay prikaz)
    EventBus.$on('table-transfer-starting', async () => {
      console.log('PanelPaymentSelection: Primio table-transfer-starting event')
      // Ne postavljamo isProcessingTransfer ovdje - to će napraviti sama metoda onAddItemsToTable/onCreateNewTable
      // Dodaj delay da se osigura da se overlay renderira nakon što metoda postavi flag
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 100))
      console.log('PanelPaymentSelection: Čekam da metoda postavi isProcessingTransfer flag')
    })

    EventBus.$on('table-transfer-completed', () => {
      this.saveDisabledAfterSplit = true
    })

    // Initialize tables scroll state after DOM is ready
    this.$nextTick(() => {
      this.updateTablesScrollState()
      // Add resize listener to update scroll state
      window.addEventListener('resize', this.updateTablesScrollState)
    })

    // if (state.getPrinterLib() === 'BIXOLON80') {
    //   const issueID = 1
    //   printerInit(issueID)
    //   state.setPosPrinterSettings(2)
    // } else if (state.getPrinter() === 'UNIVERSAL') {
    //   initPrintManager()
    // }

    // initPrintManager()

    // Listen for payment completion to unlock payment processing
    EventBus.$off('payment-completed-success')
    EventBus.$on('payment-completed-success', (receiptNumber) => {
      this.isProcessingPayment = false
      if (receiptNumber) {
        this.processingReceiptNumbers.delete(receiptNumber)
        console.log('✅ Račun broj', receiptNumber, 'uklonjen iz Set-a (uspješno). Preostalo:', Array.from(this.processingReceiptNumbers))
      }
    })

    // Listen for error-return to unlock payment processing
    EventBus.$off('error-return')
    EventBus.$on('error-return', (receiptNumber) => {
      this.isProcessingPayment = false
      if (receiptNumber) {
        this.processingReceiptNumbers.delete(receiptNumber)
        console.log('✅ Račun broj', receiptNumber, 'uklonjen iz Set-a (greška). Preostalo:', Array.from(this.processingReceiptNumbers))
      }
    })

    EventBus.$off('preview_receipt')
    EventBus.$on('preview_receipt', (method, type) => {
      this.previewReceipt(method, type)
    })

    EventBus.$off('avans')
    EventBus.$on('avans', () => {
      this.$refs.r1ReceiptPaymentDialog.open()
    })

    EventBus.$off('preview_receipt_r')
    EventBus.$on('preview_receipt_r', (method, type) => {
      this.insertPreviewAccountDetails(method, type)
    })

    EventBus.$off('clear-reload-tables')
    EventBus.$on('clear-reload-tables', () => {
      this.selectedTables = []
      this.getTables()
      this.selectedTable = new Table()
    })

    EventBus.$off('clear-table')
    EventBus.$on('clear-table', (paymentDone) => {
      this.removeOrderFromTable(paymentDone)
    })

    // EventBus.$off('set-mode')
    EventBus.$on('set-mode', (editMode) => {
      this.editMode = editMode
    })

    EventBus.$off('set-orders-view')
    EventBus.$on('set-orders-view', (ordersView) => {
      this.ordersView = ordersView
    })

    EventBus.$off('save-receipt-note')
    EventBus.$on('save-receipt-note', (receiptNote) => {
      this.receiptNote = receiptNote
    })

    EventBus.$off('deliveryFinishSimplePayment')
    EventBus.$on('deliveryFinishSimplePayment', (deliveryService, paymentMethod) => {
      this.finishPayment(paymentMethod, 'DELIVERY', deliveryService, '')
    })

    EventBus.$off('select-table-from-floor-plan')
    EventBus.$on('select-table-from-floor-plan', (tableId) => {
      const table = this.availableTables.find(t => t.id === tableId)
      if (table) {
        this.onTableCellClick(table)
      }
    })

    EventBus.$off('floor-plan-mode-changed')
    EventBus.$on('floor-plan-mode-changed', (useFloorPlan) => {
      this.useFloorPlan = useFloorPlan
    })

    // Listen for new table settings changes
    EventBus.$off('table-settings-changed')
    EventBus.$on('table-settings-changed', ({ useTables, tableMode }) => {
      this.useTables = useTables
      this.tableMode = tableMode
      // Update useFloorPlan for backward compatibility
      this.useFloorPlan = useTables && tableMode === 'floor'
    })

    EventBus.$off('table-saved-successfully')
    EventBus.$on('table-saved-successfully', () => {
      this.showSuccessSnackbar = true
    })

    this.getMultiplier()
    this.setDefaults()
    this.minIssueDate = toISOLocal(new Date())
    this.listeners.push(
      df
        .doc(`cash_registers/${state.getCashRegister().id}`)
        .onSnapshot((doc) => {
          if (doc && doc.data()) {
            this.offer_sequence = doc.data().offer_sequence
            this.bill_sequence = doc.data().bill_sequence
            this.last_receipt = doc.data().last_receipt_issued_timestamp
            this.cashRegisterForTerminal = doc.data()
            if (this.last_receipt) {
              this.minIssueDate = toISOLocal(
                new Date(this.last_receipt * 1000)
              )
            } else {
              this.minIssueDate = toISOLocal(new Date())
            }
          }
        })
    )

    this.orgUnits = []
    let query = df.collection(`location_units/${state.getPointOfSale().id}/units`)
    let listener = query.onSnapshot((doc) => {
      doc.docs.forEach((rec) => {
        this.orgUnits.push(rec.data())
      })
    })
    this.listeners.push(listener)

    this.printers = []
    query = df.collection(`location_printers/${state.getPointOfSale().id}/printers`)
    listener = query.onSnapshot((doc) => {
      doc.docs.forEach((rec) => {
        this.printers.push(rec.data())
      })
    })

    this.listeners.push(listener)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleButtonKeyPress)
    window.removeEventListener('resize', this.updateTablesScrollState)
    if (this.listeners) {
      this.detachListeners()
    }
    // Remove payment methods configuration update listener
    this.$root.$off('payment-methods-updated')
    // Remove table transfer starting listener
    EventBus.$off('table-transfer-starting')
    EventBus.$off('table-transfer-completed')
  }
}
</script>

<style scoped>
/* Tables wrapper */
.tables-wrapper {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 64px - var(--product-grid-height, 250px) - 8px);
  padding-bottom: 60px;
}

/* Tables scroll container */
.tables-scroll-container {
  max-height: calc(100vh - 64px - var(--product-grid-height, 250px) - 56px - 58px - 58px - 94px);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  margin-top: 12px;
  width: calc(100% + 24px);
  margin-left: -12px;
  margin-right: -12px;
}

/* Remove negative margin from v-row inside scroll container */
.tables-scroll-container .row {
  margin: 0 !important;
}

/* Hide scrollbar completely but keep scroll functionality */
.tables-scroll-container::-webkit-scrollbar {
  display: none;
}

.tables-scroll-container {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Scroll buttons - Transparent glass style */
.scroll-button {
  background: rgba(255, 255, 255, 0.75) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  height: 48px !important;
  min-height: 48px !important;
  margin: 6px 0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.scroll-button:hover {
  background: rgba(255, 255, 255, 0.85) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-1px);
}

.scroll-button .v-icon {
  font-size: 28px !important;
  color: #3989C9 !important;
}

/* Scroll Up Button - Overlay at top */
.scroll-button-row-up {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 10 !important;
}

/* Scroll Down Button - Fixed at screen bottom */
.scroll-button-row-down {
  position: fixed !important;
  bottom: 12px !important;
  left: calc(66.666% + 52px) !important;
  right: 12px !important;
  z-index: 100 !important;
}

#container {
  overflow-x: hidden;
  overflow-y: none;
  cursor: grab;
  touch-action: none;
  /* border: 1px solid#fd0000; */
  margin-top: 12px;
}

@media only screen and (max-height: 899px) {
  #container {
    max-height: 193px;
  }

  span.tile {
    display: block;
    white-space: normal;
    max-width: 180px;
  }
}

@media only screen and (min-height: 900px) {
  #container {
    max-height: 440px;
  }

  span.tile {
    display: block;
    white-space: normal;
    max-width: 120px;
  }
}

.panel-cell {
  padding: 0 2px 2px 0;
}

.label {
  font-size: 0.6rem;
  color: white;
  min-width: 90px;
}

.text-wrap {
  width: min-content;
  margin: auto;
}

.disable-events {
  pointer-events: none;
  background-color: #e0e0e0;
}

.accent-btn {
  animation: glowing 700ms infinite;
  font-weight: 700;
}

.darkblue {
  background: rgba(255, 255, 255, 0.85) !important;
  color: #3989c9 !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.darkblue:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.darkblue .white--text,
.darkblue span.white--text,
.darkblue.white--text {
  color: #3989c9 !important;
}

.darkblue .v-icon,
.darkblue i.v-icon {
  color: #3989c9 !important;
}

/* Override inline color prop for payment buttons (both uppercase and lowercase) */
.v-btn[color="#2C5A90"],
.v-btn[color="#2c5a90"] {
  background: rgba(255, 255, 255, 0.85) !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-btn[color="#2C5A90"]:hover:not(:disabled),
.v-btn[color="#2c5a90"]:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.v-btn[color="#2C5A90"] .white--text,
.v-btn[color="#2C5A90"] span.white--text,
.v-btn[color="#2c5a90"] .white--text,
.v-btn[color="#2c5a90"] span.white--text {
  color: #3989c9 !important;
}

.v-btn[color="#2C5A90"] .v-icon,
.v-btn[color="#2c5a90"] .v-icon {
  color: #3989c9 !important;
}

.btn-lg {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-md {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-sm {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-purple {
  background: rgba(255, 255, 255, 0.85) !important;
  color: #6154a4 !important;
  border: 1px solid rgba(97, 84, 164, 0.2) !important;
  box-shadow: 0 2px 8px rgba(97, 84, 164, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.btn-purple:hover {
  box-shadow: 0 4px 12px rgba(97, 84, 164, 0.25) !important;
  border-color: rgba(97, 84, 164, 0.3) !important;
  transform: translateY(-1px);
}

.btn-purple .white--text,
.btn-purple span.white--text,
.btn-purple.white--text {
  color: #6154a4 !important;
}

.btn-purple .v-icon,
.btn-purple i.v-icon {
  color: #6154a4 !important;
}

/* Glass-morphism Payment Button Styles */
.payment-btn-glass {
  background: linear-gradient(135deg, #36485B 0%, #307CC1 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 2px 8px rgba(48, 124, 193, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.payment-btn-glass:hover:not(:disabled) {
  background: linear-gradient(135deg, #2a3947 0%, #2568a8 100%) !important;
  box-shadow: 0 4px 16px rgba(48, 124, 193, 0.5) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px);
}

.payment-btn-glass:disabled {
  opacity: 0.6 !important;
  background: linear-gradient(135deg, rgba(54, 72, 91, 0.3) 0%, rgba(48, 124, 193, 0.3) 100%) !important;
  box-shadow: 0 1px 4px rgba(48, 124, 193, 0.1) !important;
}

.payment-btn-glass:disabled .btn-text-glass,
.payment-btn-glass:disabled .icon-glass {
  color: rgba(255, 255, 255, 0.5) !important;
}

.btn-text-glass {
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
}

.icon-glass {
  color: white !important;
}

/* Save Button Glass-morphism Styles (Purple) */
.save-btn-glass {
  background: linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(87, 74, 144, 0.45) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.save-btn-glass:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(77, 64, 124, 1) 0%, rgba(96, 67, 154, 1) 50%, rgba(77, 64, 124, 1) 100%) !important;
  box-shadow: 0 8px 20px rgba(87, 74, 144, 0.7) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.02);
}

.save-btn-glass:disabled {
  opacity: 0.6 !important;
  background: linear-gradient(135deg, rgba(97, 84, 164, 0.3) 0%, rgba(126, 87, 194, 0.25) 50%, rgba(97, 84, 164, 0.3) 100%) !important;
  box-shadow: 0 1px 4px rgba(97, 84, 164, 0.1) !important;
}

.save-btn-glass:disabled .btn-text-glass {
  color: rgba(255, 255, 255, 0.5) !important;
}

.notification-green {
  font-size: 12px;
  background-color: #8ff4a2;
  font-weight: bold;
}

.notification-yellow {
  font-size: 12px;
  background-color: #edf68b;
  font-weight: bold;
}

.notification-red {
  font-size: 12px;
  background-color: #e898a0;
  color: white;
  font-weight: bold;
}

.notification-purple {
  font-size: 12px;
  background: linear-gradient(135deg, #36485B 0%, #307CC1 100%);
  font-weight: bold;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

/* Stolovi Button - No animation, no rounded corners */
.stolovi-btn {
  border-radius: 0 !important;
  transition: none !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border-top: none !important;
  border-bottom: none !important;
}

.stolovi-btn:hover:not(:disabled) {
  transform: none !important;
}

/* Stolovi Bottom Div - Remove gap */
.stolovi-bottom {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Table Selection Dialog - Glass-morphism styling */
.table-selection-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
}

.table-selection-header {
  background: linear-gradient(
    135deg,
    rgba(255, 152, 0, 0.5) 0%,
    rgba(251, 140, 0, 0.45) 50%,
    rgba(245, 124, 0, 0.5) 100%
  ) !important;
  padding: 20px 24px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.table-selection-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.table-selection-title {
  color: white !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

.table-selection-text {
  padding: 16px 24px 8px 24px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
}

.table-selection-buttons {
  padding: 8px 24px 24px 24px !important;
}

/* Base button style for all table selection buttons */
.table-btn-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 8px;
}

.table-btn-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px !important;
  color: white !important;
  text-transform: uppercase;
  line-height: 1.2 !important;
}

/* Cancel button - Gray gradient style */
.table-selection-cancel-btn {
  background: linear-gradient(
    135deg,
    rgba(120, 120, 120, 0.95) 0%,
    rgba(90, 90, 90, 0.9) 100%
  ) !important;
  border-radius: 12px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 6px 20px rgba(120, 120, 120, 0.4) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  min-height: 120px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-cancel-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(120, 120, 120, 1) 0%,
    rgba(90, 90, 90, 1) 100%
  ) !important;
  box-shadow: 0 10px 28px rgba(120, 120, 120, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-4px) scale(1.02);
}

.table-selection-cancel-btn .v-icon {
  color: white !important;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-cancel-btn:hover .v-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
}

/* Delete button - Red gradient style */
.table-selection-delete-btn {
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.95) 0%,
    rgba(229, 57, 53, 0.9) 100%
  ) !important;
  border-radius: 12px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  min-height: 120px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-delete-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 1) 0%,
    rgba(229, 57, 53, 1) 100%
  ) !important;
  box-shadow: 0 10px 28px rgba(244, 67, 54, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-4px) scale(1.02);
}

.table-selection-delete-btn .v-icon {
  color: white !important;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-delete-btn:hover .v-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
}

/* Add to table button - Green gradient style */
.table-selection-add-btn {
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%
  ) !important;
  border-radius: 12px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  min-height: 120px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-add-btn:hover:not(:disabled) {
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%
  ) !important;
  box-shadow: 0 10px 28px rgba(76, 175, 80, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-4px) scale(1.02);
}

.table-selection-add-btn .v-icon {
  color: white !important;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.table-selection-add-btn:hover .v-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
}
</style>
